/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  "grinning face": {
    "unicode": "😀"
  },
  "grinning face with big eyes": {
    "unicode": "😃"
  },
  "grinning face with smiling eyes": {
    "unicode": "😄"
  },
  "beaming face with smiling eyes": {
    "unicode": "😁"
  },
  "grinning squinting face": {
    "unicode": "😆"
  },
  "grinning face with sweat": {
    "unicode": "😅"
  },
  "rolling on the floor laughing": {
    "unicode": "🤣"
  },
  "face with tears of joy": {
    "unicode": "😂"
  },
  "slightly smiling face": {
    "unicode": "🙂"
  },
  "upside-down face": {
    "unicode": "🙃"
  },
  "winking face": {
    "unicode": "😉"
  },
  "smiling face with smiling eyes": {
    "unicode": "😊"
  },
  "smiling face with halo": {
    "unicode": "😇"
  },
  "smiling face with hearts": {
    "unicode": "🥰"
  },
  "smiling face with heart-eyes": {
    "unicode": "😍"
  },
  "star-struck": {
    "unicode": "🤩"
  },
  "face blowing a kiss": {
    "unicode": "😘"
  },
  "kissing face": {
    "unicode": "😗"
  },
  "smiling face": {
    "unicode": "☺️"
  },
  "kissing face with closed eyes": {
    "unicode": "😚"
  },
  "kissing face with smiling eyes": {
    "unicode": "😙"
  },
  "smiling face with tear": {
    "unicode": "🥲"
  },
  "face savoring food": {
    "unicode": "😋"
  },
  "face with tongue": {
    "unicode": "😛"
  },
  "winking face with tongue": {
    "unicode": "😜"
  },
  "zany face": {
    "unicode": "🤪"
  },
  "squinting face with tongue": {
    "unicode": "😝"
  },
  "money-mouth face": {
    "unicode": "🤑"
  },
  "hugging face": {
    "unicode": "🤗"
  },
  "face with hand over mouth": {
    "unicode": "🤭"
  },
  "shushing face": {
    "unicode": "🤫"
  },
  "thinking face": {
    "unicode": "🤔"
  },
  "zipper-mouth face": {
    "unicode": "🤐"
  },
  "face with raised eyebrow": {
    "unicode": "🤨"
  },
  "neutral face": {
    "unicode": "😐"
  },
  "expressionless face": {
    "unicode": "😑"
  },
  "face without mouth": {
    "unicode": "😶"
  },
  "smirking face": {
    "unicode": "😏"
  },
  "unamused face": {
    "unicode": "😒"
  },
  "face with rolling eyes": {
    "unicode": "🙄"
  },
  "grimacing face": {
    "unicode": "😬"
  },
  "lying face": {
    "unicode": "🤥"
  },
  "relieved face": {
    "unicode": "😌"
  },
  "pensive face": {
    "unicode": "😔"
  },
  "sleepy face": {
    "unicode": "😪"
  },
  "drooling face": {
    "unicode": "🤤"
  },
  "sleeping face": {
    "unicode": "😴"
  },
  "face with medical mask": {
    "unicode": "😷"
  },
  "face with thermometer": {
    "unicode": "🤒"
  },
  "face with head-bandage": {
    "unicode": "🤕"
  },
  "nauseated face": {
    "unicode": "🤢"
  },
  "face vomiting": {
    "unicode": "🤮"
  },
  "sneezing face": {
    "unicode": "🤧"
  },
  "hot face": {
    "unicode": "🥵"
  },
  "cold face": {
    "unicode": "🥶"
  },
  "woozy face": {
    "unicode": "🥴"
  },
  "dizzy face": {
    "unicode": "😵"
  },
  "exploding head": {
    "unicode": "🤯"
  },
  "cowboy hat face": {
    "unicode": "🤠"
  },
  "partying face": {
    "unicode": "🥳"
  },
  "disguised face": {
    "unicode": "🥸"
  },
  "smiling face with sunglasses": {
    "unicode": "😎"
  },
  "nerd face": {
    "unicode": "🤓"
  },
  "face with monocle": {
    "unicode": "🧐"
  },
  "confused face": {
    "unicode": "😕"
  },
  "worried face": {
    "unicode": "😟"
  },
  "slightly frowning face": {
    "unicode": "🙁"
  },
  "frowning face": {
    "unicode": "☹️"
  },
  "face with open mouth": {
    "unicode": "😮"
  },
  "hushed face": {
    "unicode": "😯"
  },
  "astonished face": {
    "unicode": "😲"
  },
  "flushed face": {
    "unicode": "😳"
  },
  "pleading face": {
    "unicode": "🥺"
  },
  "frowning face with open mouth": {
    "unicode": "😦"
  },
  "anguished face": {
    "unicode": "😧"
  },
  "fearful face": {
    "unicode": "😨"
  },
  "anxious face with sweat": {
    "unicode": "😰"
  },
  "sad but relieved face": {
    "unicode": "😥"
  },
  "crying face": {
    "unicode": "😢"
  },
  "loudly crying face": {
    "unicode": "😭"
  },
  "face screaming in fear": {
    "unicode": "😱"
  },
  "confounded face": {
    "unicode": "😖"
  },
  "persevering face": {
    "unicode": "😣"
  },
  "disappointed face": {
    "unicode": "😞"
  },
  "downcast face with sweat": {
    "unicode": "😓"
  },
  "weary face": {
    "unicode": "😩"
  },
  "tired face": {
    "unicode": "😫"
  },
  "yawning face": {
    "unicode": "🥱"
  },
  "face with steam from nose": {
    "unicode": "😤"
  },
  "pouting face": {
    "unicode": "😡"
  },
  "angry face": {
    "unicode": "😠"
  },
  "face with symbols on mouth": {
    "unicode": "🤬"
  },
  "smiling face with horns": {
    "unicode": "😈"
  },
  "angry face with horns": {
    "unicode": "👿"
  },
  "skull": {
    "unicode": "💀"
  },
  "skull and crossbones": {
    "unicode": "☠️"
  },
  "pile of poo": {
    "unicode": "💩"
  },
  "clown face": {
    "unicode": "🤡"
  },
  "ogre": {
    "unicode": "👹"
  },
  "goblin": {
    "unicode": "👺"
  },
  "ghost": {
    "unicode": "👻"
  },
  "alien": {
    "unicode": "👽"
  },
  "alien monster": {
    "unicode": "👾"
  },
  "robot": {
    "unicode": "🤖"
  },
  "grinning cat": {
    "unicode": "😺"
  },
  "grinning cat with smiling eyes": {
    "unicode": "😸"
  },
  "cat with tears of joy": {
    "unicode": "😹"
  },
  "smiling cat with heart-eyes": {
    "unicode": "😻"
  },
  "cat with wry smile": {
    "unicode": "😼"
  },
  "kissing cat": {
    "unicode": "😽"
  },
  "weary cat": {
    "unicode": "🙀"
  },
  "crying cat": {
    "unicode": "😿"
  },
  "pouting cat": {
    "unicode": "😾"
  },
  "see-no-evil monkey": {
    "unicode": "🙈"
  },
  "hear-no-evil monkey": {
    "unicode": "🙉"
  },
  "speak-no-evil monkey": {
    "unicode": "🙊"
  },
  "kiss mark": {
    "unicode": "💋"
  },
  "love letter": {
    "unicode": "💌"
  },
  "heart with arrow": {
    "unicode": "💘"
  },
  "heart with ribbon": {
    "unicode": "💝"
  },
  "sparkling heart": {
    "unicode": "💖"
  },
  "growing heart": {
    "unicode": "💗"
  },
  "beating heart": {
    "unicode": "💓"
  },
  "revolving hearts": {
    "unicode": "💞"
  },
  "two hearts": {
    "unicode": "💕"
  },
  "heart decoration": {
    "unicode": "💟"
  },
  "heart exclamation": {
    "unicode": "❣️"
  },
  "broken heart": {
    "unicode": "💔"
  },
  "red heart": {
    "unicode": "❤️"
  },
  "orange heart": {
    "unicode": "🧡"
  },
  "yellow heart": {
    "unicode": "💛"
  },
  "green heart": {
    "unicode": "💚"
  },
  "blue heart": {
    "unicode": "💙"
  },
  "purple heart": {
    "unicode": "💜"
  },
  "brown heart": {
    "unicode": "🤎"
  },
  "black heart": {
    "unicode": "🖤"
  },
  "white heart": {
    "unicode": "🤍"
  },
  "hundred points": {
    "unicode": "💯"
  },
  "anger symbol": {
    "unicode": "💢"
  },
  "collision": {
    "unicode": "💥"
  },
  "dizzy": {
    "unicode": "💫"
  },
  "sweat droplets": {
    "unicode": "💦"
  },
  "dashing away": {
    "unicode": "💨"
  },
  "hole": {
    "unicode": "🕳️"
  },
  "bomb": {
    "unicode": "💣"
  },
  "speech balloon": {
    "unicode": "💬"
  },
  "eye in speech bubble": {
    "unicode": "👁️‍🗨️"
  },
  "left speech bubble": {
    "unicode": "🗨️"
  },
  "right anger bubble": {
    "unicode": "🗯️"
  },
  "thought balloon": {
    "unicode": "💭"
  },
  "zzz": {
    "unicode": "💤"
  },
  "waving hand": {
    "unicode": "👋"
  },
  "raised back of hand": {
    "unicode": "🤚"
  },
  "hand with fingers splayed": {
    "unicode": "🖐️"
  },
  "raised hand": {
    "unicode": "✋"
  },
  "vulcan salute": {
    "unicode": "🖖"
  },
  "OK hand": {
    "unicode": "👌"
  },
  "pinched fingers": {
    "unicode": "🤌"
  },
  "pinching hand": {
    "unicode": "🤏"
  },
  "victory hand": {
    "unicode": "✌️"
  },
  "crossed fingers": {
    "unicode": "🤞"
  },
  "love-you gesture": {
    "unicode": "🤟"
  },
  "sign of the horns": {
    "unicode": "🤘"
  },
  "call me hand": {
    "unicode": "🤙"
  },
  "backhand index pointing left": {
    "unicode": "👈"
  },
  "backhand index pointing right": {
    "unicode": "👉"
  },
  "backhand index pointing up": {
    "unicode": "👆"
  },
  "middle finger": {
    "unicode": "🖕"
  },
  "backhand index pointing down": {
    "unicode": "👇"
  },
  "index pointing up": {
    "unicode": "☝️"
  },
  "thumbs up": {
    "unicode": "👍"
  },
  "thumbs down": {
    "unicode": "👎"
  },
  "raised fist": {
    "unicode": "✊"
  },
  "oncoming fist": {
    "unicode": "👊"
  },
  "left-facing fist": {
    "unicode": "🤛"
  },
  "right-facing fist": {
    "unicode": "🤜"
  },
  "clapping hands": {
    "unicode": "👏"
  },
  "raising hands": {
    "unicode": "🙌"
  },
  "open hands": {
    "unicode": "👐"
  },
  "palms up together": {
    "unicode": "🤲"
  },
  "handshake": {
    "unicode": "🤝"
  },
  "folded hands": {
    "unicode": "🙏"
  },
  "writing hand": {
    "unicode": "✍️"
  },
  "nail polish": {
    "unicode": "💅"
  },
  "selfie": {
    "unicode": "🤳"
  },
  "flexed biceps": {
    "unicode": "💪"
  },
  "mechanical arm": {
    "unicode": "🦾"
  },
  "mechanical leg": {
    "unicode": "🦿"
  },
  "leg": {
    "unicode": "🦵"
  },
  "foot": {
    "unicode": "🦶"
  },
  "ear": {
    "unicode": "👂"
  },
  "ear with hearing aid": {
    "unicode": "🦻"
  },
  "nose": {
    "unicode": "👃"
  },
  "brain": {
    "unicode": "🧠"
  },
  "anatomical heart": {
    "unicode": "🫀"
  },
  "lungs": {
    "unicode": "🫁"
  },
  "tooth": {
    "unicode": "🦷"
  },
  "bone": {
    "unicode": "🦴"
  },
  "eyes": {
    "unicode": "👀"
  },
  "eye": {
    "unicode": "👁️"
  },
  "tongue": {
    "unicode": "👅"
  },
  "mouth": {
    "unicode": "👄"
  },
  "baby": {
    "unicode": "👶"
  },
  "child": {
    "unicode": "🧒"
  },
  "boy": {
    "unicode": "👦"
  },
  "girl": {
    "unicode": "👧"
  },
  "person": {
    "unicode": "🧑"
  },
  "person: blond hair": {
    "unicode": "👱"
  },
  "man": {
    "unicode": "👨"
  },
  "man: beard": {
    "unicode": "🧔"
  },
  "man: red hair": {
    "unicode": "👨‍🦰"
  },
  "man: curly hair": {
    "unicode": "👨‍🦱"
  },
  "man: white hair": {
    "unicode": "👨‍🦳"
  },
  "man: bald": {
    "unicode": "👨‍🦲"
  },
  "woman": {
    "unicode": "👩"
  },
  "woman: red hair": {
    "unicode": "👩‍🦰"
  },
  "person: red hair": {
    "unicode": "🧑‍🦰"
  },
  "woman: curly hair": {
    "unicode": "👩‍🦱"
  },
  "person: curly hair": {
    "unicode": "🧑‍🦱"
  },
  "woman: white hair": {
    "unicode": "👩‍🦳"
  },
  "person: white hair": {
    "unicode": "🧑‍🦳"
  },
  "woman: bald": {
    "unicode": "👩‍🦲"
  },
  "person: bald": {
    "unicode": "🧑‍🦲"
  },
  "woman: blond hair": {
    "unicode": "👱‍♀️"
  },
  "man: blond hair": {
    "unicode": "👱‍♂️"
  },
  "older person": {
    "unicode": "🧓"
  },
  "old man": {
    "unicode": "👴"
  },
  "old woman": {
    "unicode": "👵"
  },
  "person frowning": {
    "unicode": "🙍"
  },
  "man frowning": {
    "unicode": "🙍‍♂️"
  },
  "woman frowning": {
    "unicode": "🙍‍♀️"
  },
  "person pouting": {
    "unicode": "🙎"
  },
  "man pouting": {
    "unicode": "🙎‍♂️"
  },
  "woman pouting": {
    "unicode": "🙎‍♀️"
  },
  "person gesturing NO": {
    "unicode": "🙅"
  },
  "man gesturing NO": {
    "unicode": "🙅‍♂️"
  },
  "woman gesturing NO": {
    "unicode": "🙅‍♀️"
  },
  "person gesturing OK": {
    "unicode": "🙆"
  },
  "man gesturing OK": {
    "unicode": "🙆‍♂️"
  },
  "woman gesturing OK": {
    "unicode": "🙆‍♀️"
  },
  "person tipping hand": {
    "unicode": "💁"
  },
  "man tipping hand": {
    "unicode": "💁‍♂️"
  },
  "woman tipping hand": {
    "unicode": "💁‍♀️"
  },
  "person raising hand": {
    "unicode": "🙋"
  },
  "man raising hand": {
    "unicode": "🙋‍♂️"
  },
  "woman raising hand": {
    "unicode": "🙋‍♀️"
  },
  "deaf person": {
    "unicode": "🧏"
  },
  "deaf man": {
    "unicode": "🧏‍♂️"
  },
  "deaf woman": {
    "unicode": "🧏‍♀️"
  },
  "person bowing": {
    "unicode": "🙇"
  },
  "man bowing": {
    "unicode": "🙇‍♂️"
  },
  "woman bowing": {
    "unicode": "🙇‍♀️"
  },
  "person facepalming": {
    "unicode": "🤦"
  },
  "man facepalming": {
    "unicode": "🤦‍♂️"
  },
  "woman facepalming": {
    "unicode": "🤦‍♀️"
  },
  "person shrugging": {
    "unicode": "🤷"
  },
  "man shrugging": {
    "unicode": "🤷‍♂️"
  },
  "woman shrugging": {
    "unicode": "🤷‍♀️"
  },
  "health worker": {
    "unicode": "🧑‍⚕️"
  },
  "man health worker": {
    "unicode": "👨‍⚕️"
  },
  "woman health worker": {
    "unicode": "👩‍⚕️"
  },
  "student": {
    "unicode": "🧑‍🎓"
  },
  "man student": {
    "unicode": "👨‍🎓"
  },
  "woman student": {
    "unicode": "👩‍🎓"
  },
  "teacher": {
    "unicode": "🧑‍🏫"
  },
  "man teacher": {
    "unicode": "👨‍🏫"
  },
  "woman teacher": {
    "unicode": "👩‍🏫"
  },
  "judge": {
    "unicode": "🧑‍⚖️"
  },
  "man judge": {
    "unicode": "👨‍⚖️"
  },
  "woman judge": {
    "unicode": "👩‍⚖️"
  },
  "farmer": {
    "unicode": "🧑‍🌾"
  },
  "man farmer": {
    "unicode": "👨‍🌾"
  },
  "woman farmer": {
    "unicode": "👩‍🌾"
  },
  "cook": {
    "unicode": "🧑‍🍳"
  },
  "man cook": {
    "unicode": "👨‍🍳"
  },
  "woman cook": {
    "unicode": "👩‍🍳"
  },
  "mechanic": {
    "unicode": "🧑‍🔧"
  },
  "man mechanic": {
    "unicode": "👨‍🔧"
  },
  "woman mechanic": {
    "unicode": "👩‍🔧"
  },
  "factory worker": {
    "unicode": "🧑‍🏭"
  },
  "man factory worker": {
    "unicode": "👨‍🏭"
  },
  "woman factory worker": {
    "unicode": "👩‍🏭"
  },
  "office worker": {
    "unicode": "🧑‍💼"
  },
  "man office worker": {
    "unicode": "👨‍💼"
  },
  "woman office worker": {
    "unicode": "👩‍💼"
  },
  "scientist": {
    "unicode": "🧑‍🔬"
  },
  "man scientist": {
    "unicode": "👨‍🔬"
  },
  "woman scientist": {
    "unicode": "👩‍🔬"
  },
  "technologist": {
    "unicode": "🧑‍💻"
  },
  "man technologist": {
    "unicode": "👨‍💻"
  },
  "woman technologist": {
    "unicode": "👩‍💻"
  },
  "singer": {
    "unicode": "🧑‍🎤"
  },
  "man singer": {
    "unicode": "👨‍🎤"
  },
  "woman singer": {
    "unicode": "👩‍🎤"
  },
  "artist": {
    "unicode": "🧑‍🎨"
  },
  "man artist": {
    "unicode": "👨‍🎨"
  },
  "woman artist": {
    "unicode": "👩‍🎨"
  },
  "pilot": {
    "unicode": "🧑‍✈️"
  },
  "man pilot": {
    "unicode": "👨‍✈️"
  },
  "woman pilot": {
    "unicode": "👩‍✈️"
  },
  "astronaut": {
    "unicode": "🧑‍🚀"
  },
  "man astronaut": {
    "unicode": "👨‍🚀"
  },
  "woman astronaut": {
    "unicode": "👩‍🚀"
  },
  "firefighter": {
    "unicode": "🧑‍🚒"
  },
  "man firefighter": {
    "unicode": "👨‍🚒"
  },
  "woman firefighter": {
    "unicode": "👩‍🚒"
  },
  "police officer": {
    "unicode": "👮"
  },
  "man police officer": {
    "unicode": "👮‍♂️"
  },
  "woman police officer": {
    "unicode": "👮‍♀️"
  },
  "detective": {
    "unicode": "🕵️"
  },
  "man detective": {
    "unicode": "🕵️‍♂️"
  },
  "woman detective": {
    "unicode": "🕵️‍♀️"
  },
  "guard": {
    "unicode": "💂"
  },
  "man guard": {
    "unicode": "💂‍♂️"
  },
  "woman guard": {
    "unicode": "💂‍♀️"
  },
  "ninja": {
    "unicode": "🥷"
  },
  "construction worker": {
    "unicode": "👷"
  },
  "man construction worker": {
    "unicode": "👷‍♂️"
  },
  "woman construction worker": {
    "unicode": "👷‍♀️"
  },
  "prince": {
    "unicode": "🤴"
  },
  "princess": {
    "unicode": "👸"
  },
  "person wearing turban": {
    "unicode": "👳"
  },
  "man wearing turban": {
    "unicode": "👳‍♂️"
  },
  "woman wearing turban": {
    "unicode": "👳‍♀️"
  },
  "person with skullcap": {
    "unicode": "👲"
  },
  "woman with headscarf": {
    "unicode": "🧕"
  },
  "person in tuxedo": {
    "unicode": "🤵"
  },
  "man in tuxedo": {
    "unicode": "🤵‍♂️"
  },
  "woman in tuxedo": {
    "unicode": "🤵‍♀️"
  },
  "person with veil": {
    "unicode": "👰"
  },
  "man with veil": {
    "unicode": "👰‍♂️"
  },
  "woman with veil": {
    "unicode": "👰‍♀️"
  },
  "pregnant woman": {
    "unicode": "🤰"
  },
  "breast-feeding": {
    "unicode": "🤱"
  },
  "woman feeding baby": {
    "unicode": "👩‍🍼"
  },
  "man feeding baby": {
    "unicode": "👨‍🍼"
  },
  "person feeding baby": {
    "unicode": "🧑‍🍼"
  },
  "baby angel": {
    "unicode": "👼"
  },
  "Santa Claus": {
    "unicode": "🎅"
  },
  "Mrs. Claus": {
    "unicode": "🤶"
  },
  "mx claus": {
    "unicode": "🧑‍🎄"
  },
  "superhero": {
    "unicode": "🦸"
  },
  "man superhero": {
    "unicode": "🦸‍♂️"
  },
  "woman superhero": {
    "unicode": "🦸‍♀️"
  },
  "supervillain": {
    "unicode": "🦹"
  },
  "man supervillain": {
    "unicode": "🦹‍♂️"
  },
  "woman supervillain": {
    "unicode": "🦹‍♀️"
  },
  "mage": {
    "unicode": "🧙"
  },
  "man mage": {
    "unicode": "🧙‍♂️"
  },
  "woman mage": {
    "unicode": "🧙‍♀️"
  },
  "fairy": {
    "unicode": "🧚"
  },
  "man fairy": {
    "unicode": "🧚‍♂️"
  },
  "woman fairy": {
    "unicode": "🧚‍♀️"
  },
  "vampire": {
    "unicode": "🧛"
  },
  "man vampire": {
    "unicode": "🧛‍♂️"
  },
  "woman vampire": {
    "unicode": "🧛‍♀️"
  },
  "merperson": {
    "unicode": "🧜"
  },
  "merman": {
    "unicode": "🧜‍♂️"
  },
  "mermaid": {
    "unicode": "🧜‍♀️"
  },
  "elf": {
    "unicode": "🧝"
  },
  "man elf": {
    "unicode": "🧝‍♂️"
  },
  "woman elf": {
    "unicode": "🧝‍♀️"
  },
  "genie": {
    "unicode": "🧞"
  },
  "man genie": {
    "unicode": "🧞‍♂️"
  },
  "woman genie": {
    "unicode": "🧞‍♀️"
  },
  "zombie": {
    "unicode": "🧟"
  },
  "man zombie": {
    "unicode": "🧟‍♂️"
  },
  "woman zombie": {
    "unicode": "🧟‍♀️"
  },
  "person getting massage": {
    "unicode": "💆"
  },
  "man getting massage": {
    "unicode": "💆‍♂️"
  },
  "woman getting massage": {
    "unicode": "💆‍♀️"
  },
  "person getting haircut": {
    "unicode": "💇"
  },
  "man getting haircut": {
    "unicode": "💇‍♂️"
  },
  "woman getting haircut": {
    "unicode": "💇‍♀️"
  },
  "person walking": {
    "unicode": "🚶"
  },
  "man walking": {
    "unicode": "🚶‍♂️"
  },
  "woman walking": {
    "unicode": "🚶‍♀️"
  },
  "person standing": {
    "unicode": "🧍"
  },
  "man standing": {
    "unicode": "🧍‍♂️"
  },
  "woman standing": {
    "unicode": "🧍‍♀️"
  },
  "person kneeling": {
    "unicode": "🧎"
  },
  "man kneeling": {
    "unicode": "🧎‍♂️"
  },
  "woman kneeling": {
    "unicode": "🧎‍♀️"
  },
  "person with white cane": {
    "unicode": "🧑‍🦯"
  },
  "man with white cane": {
    "unicode": "👨‍🦯"
  },
  "woman with white cane": {
    "unicode": "👩‍🦯"
  },
  "person in motorized wheelchair": {
    "unicode": "🧑‍🦼"
  },
  "man in motorized wheelchair": {
    "unicode": "👨‍🦼"
  },
  "woman in motorized wheelchair": {
    "unicode": "👩‍🦼"
  },
  "person in manual wheelchair": {
    "unicode": "🧑‍🦽"
  },
  "man in manual wheelchair": {
    "unicode": "👨‍🦽"
  },
  "woman in manual wheelchair": {
    "unicode": "👩‍🦽"
  },
  "person running": {
    "unicode": "🏃"
  },
  "man running": {
    "unicode": "🏃‍♂️"
  },
  "woman running": {
    "unicode": "🏃‍♀️"
  },
  "woman dancing": {
    "unicode": "💃"
  },
  "man dancing": {
    "unicode": "🕺"
  },
  "person in suit levitating": {
    "unicode": "🕴️"
  },
  "people with bunny ears": {
    "unicode": "👯"
  },
  "men with bunny ears": {
    "unicode": "👯‍♂️"
  },
  "women with bunny ears": {
    "unicode": "👯‍♀️"
  },
  "person in steamy room": {
    "unicode": "🧖"
  },
  "man in steamy room": {
    "unicode": "🧖‍♂️"
  },
  "woman in steamy room": {
    "unicode": "🧖‍♀️"
  },
  "person climbing": {
    "unicode": "🧗"
  },
  "man climbing": {
    "unicode": "🧗‍♂️"
  },
  "woman climbing": {
    "unicode": "🧗‍♀️"
  },
  "person fencing": {
    "unicode": "🤺"
  },
  "horse racing": {
    "unicode": "🏇"
  },
  "skier": {
    "unicode": "⛷️"
  },
  "snowboarder": {
    "unicode": "🏂"
  },
  "person golfing": {
    "unicode": "🏌️"
  },
  "man golfing": {
    "unicode": "🏌️‍♂️"
  },
  "woman golfing": {
    "unicode": "🏌️‍♀️"
  },
  "person surfing": {
    "unicode": "🏄"
  },
  "man surfing": {
    "unicode": "🏄‍♂️"
  },
  "woman surfing": {
    "unicode": "🏄‍♀️"
  },
  "person rowing boat": {
    "unicode": "🚣"
  },
  "man rowing boat": {
    "unicode": "🚣‍♂️"
  },
  "woman rowing boat": {
    "unicode": "🚣‍♀️"
  },
  "person swimming": {
    "unicode": "🏊"
  },
  "man swimming": {
    "unicode": "🏊‍♂️"
  },
  "woman swimming": {
    "unicode": "🏊‍♀️"
  },
  "person bouncing ball": {
    "unicode": "⛹️"
  },
  "man bouncing ball": {
    "unicode": "⛹️‍♂️"
  },
  "woman bouncing ball": {
    "unicode": "⛹️‍♀️"
  },
  "person lifting weights": {
    "unicode": "🏋️"
  },
  "man lifting weights": {
    "unicode": "🏋️‍♂️"
  },
  "woman lifting weights": {
    "unicode": "🏋️‍♀️"
  },
  "person biking": {
    "unicode": "🚴"
  },
  "man biking": {
    "unicode": "🚴‍♂️"
  },
  "woman biking": {
    "unicode": "🚴‍♀️"
  },
  "person mountain biking": {
    "unicode": "🚵"
  },
  "man mountain biking": {
    "unicode": "🚵‍♂️"
  },
  "woman mountain biking": {
    "unicode": "🚵‍♀️"
  },
  "person cartwheeling": {
    "unicode": "🤸"
  },
  "man cartwheeling": {
    "unicode": "🤸‍♂️"
  },
  "woman cartwheeling": {
    "unicode": "🤸‍♀️"
  },
  "people wrestling": {
    "unicode": "🤼"
  },
  "men wrestling": {
    "unicode": "🤼‍♂️"
  },
  "women wrestling": {
    "unicode": "🤼‍♀️"
  },
  "person playing water polo": {
    "unicode": "🤽"
  },
  "man playing water polo": {
    "unicode": "🤽‍♂️"
  },
  "woman playing water polo": {
    "unicode": "🤽‍♀️"
  },
  "person playing handball": {
    "unicode": "🤾"
  },
  "man playing handball": {
    "unicode": "🤾‍♂️"
  },
  "woman playing handball": {
    "unicode": "🤾‍♀️"
  },
  "person juggling": {
    "unicode": "🤹"
  },
  "man juggling": {
    "unicode": "🤹‍♂️"
  },
  "woman juggling": {
    "unicode": "🤹‍♀️"
  },
  "person in lotus position": {
    "unicode": "🧘"
  },
  "man in lotus position": {
    "unicode": "🧘‍♂️"
  },
  "woman in lotus position": {
    "unicode": "🧘‍♀️"
  },
  "person taking bath": {
    "unicode": "🛀"
  },
  "person in bed": {
    "unicode": "🛌"
  },
  "people holding hands": {
    "unicode": "🧑‍🤝‍🧑"
  },
  "women holding hands": {
    "unicode": "👭"
  },
  "woman and man holding hands": {
    "unicode": "👫"
  },
  "men holding hands": {
    "unicode": "👬"
  },
  "kiss": {
    "unicode": "💏"
  },
  "kiss: woman, man": {
    "unicode": "👩‍❤️‍💋‍👨"
  },
  "kiss: man, man": {
    "unicode": "👨‍❤️‍💋‍👨"
  },
  "kiss: woman, woman": {
    "unicode": "👩‍❤️‍💋‍👩"
  },
  "couple with heart": {
    "unicode": "💑"
  },
  "couple with heart: woman, man": {
    "unicode": "👩‍❤️‍👨"
  },
  "couple with heart: man, man": {
    "unicode": "👨‍❤️‍👨"
  },
  "couple with heart: woman, woman": {
    "unicode": "👩‍❤️‍👩"
  },
  "family": {
    "unicode": "👪"
  },
  "family: man, woman, boy": {
    "unicode": "👨‍👩‍👦"
  },
  "family: man, woman, girl": {
    "unicode": "👨‍👩‍👧"
  },
  "family: man, woman, girl, boy": {
    "unicode": "👨‍👩‍👧‍👦"
  },
  "family: man, woman, boy, boy": {
    "unicode": "👨‍👩‍👦‍👦"
  },
  "family: man, woman, girl, girl": {
    "unicode": "👨‍👩‍👧‍👧"
  },
  "family: man, man, boy": {
    "unicode": "👨‍👨‍👦"
  },
  "family: man, man, girl": {
    "unicode": "👨‍👨‍👧"
  },
  "family: man, man, girl, boy": {
    "unicode": "👨‍👨‍👧‍👦"
  },
  "family: man, man, boy, boy": {
    "unicode": "👨‍👨‍👦‍👦"
  },
  "family: man, man, girl, girl": {
    "unicode": "👨‍👨‍👧‍👧"
  },
  "family: woman, woman, boy": {
    "unicode": "👩‍👩‍👦"
  },
  "family: woman, woman, girl": {
    "unicode": "👩‍👩‍👧"
  },
  "family: woman, woman, girl, boy": {
    "unicode": "👩‍👩‍👧‍👦"
  },
  "family: woman, woman, boy, boy": {
    "unicode": "👩‍👩‍👦‍👦"
  },
  "family: woman, woman, girl, girl": {
    "unicode": "👩‍👩‍👧‍👧"
  },
  "family: man, boy": {
    "unicode": "👨‍👦"
  },
  "family: man, boy, boy": {
    "unicode": "👨‍👦‍👦"
  },
  "family: man, girl": {
    "unicode": "👨‍👧"
  },
  "family: man, girl, boy": {
    "unicode": "👨‍👧‍👦"
  },
  "family: man, girl, girl": {
    "unicode": "👨‍👧‍👧"
  },
  "family: woman, boy": {
    "unicode": "👩‍👦"
  },
  "family: woman, boy, boy": {
    "unicode": "👩‍👦‍👦"
  },
  "family: woman, girl": {
    "unicode": "👩‍👧"
  },
  "family: woman, girl, boy": {
    "unicode": "👩‍👧‍👦"
  },
  "family: woman, girl, girl": {
    "unicode": "👩‍👧‍👧"
  },
  "speaking head": {
    "unicode": "🗣️"
  },
  "bust in silhouette": {
    "unicode": "👤"
  },
  "busts in silhouette": {
    "unicode": "👥"
  },
  "people hugging": {
    "unicode": "🫂"
  },
  "footprints": {
    "unicode": "👣"
  },
  "monkey face": {
    "unicode": "🐵"
  },
  "monkey": {
    "unicode": "🐒"
  },
  "gorilla": {
    "unicode": "🦍"
  },
  "orangutan": {
    "unicode": "🦧"
  },
  "dog face": {
    "unicode": "🐶"
  },
  "dog": {
    "unicode": "🐕"
  },
  "guide dog": {
    "unicode": "🦮"
  },
  "service dog": {
    "unicode": "🐕‍🦺"
  },
  "poodle": {
    "unicode": "🐩"
  },
  "wolf": {
    "unicode": "🐺"
  },
  "fox": {
    "unicode": "🦊"
  },
  "raccoon": {
    "unicode": "🦝"
  },
  "cat face": {
    "unicode": "🐱"
  },
  "cat": {
    "unicode": "🐈"
  },
  "black cat": {
    "unicode": "🐈‍⬛"
  },
  "lion": {
    "unicode": "🦁"
  },
  "tiger face": {
    "unicode": "🐯"
  },
  "tiger": {
    "unicode": "🐅"
  },
  "leopard": {
    "unicode": "🐆"
  },
  "horse face": {
    "unicode": "🐴"
  },
  "horse": {
    "unicode": "🐎"
  },
  "unicorn": {
    "unicode": "🦄"
  },
  "zebra": {
    "unicode": "🦓"
  },
  "deer": {
    "unicode": "🦌"
  },
  "bison": {
    "unicode": "🦬"
  },
  "cow face": {
    "unicode": "🐮"
  },
  "ox": {
    "unicode": "🐂"
  },
  "water buffalo": {
    "unicode": "🐃"
  },
  "cow": {
    "unicode": "🐄"
  },
  "pig face": {
    "unicode": "🐷"
  },
  "pig": {
    "unicode": "🐖"
  },
  "boar": {
    "unicode": "🐗"
  },
  "pig nose": {
    "unicode": "🐽"
  },
  "ram": {
    "unicode": "🐏"
  },
  "ewe": {
    "unicode": "🐑"
  },
  "goat": {
    "unicode": "🐐"
  },
  "camel": {
    "unicode": "🐪"
  },
  "two-hump camel": {
    "unicode": "🐫"
  },
  "llama": {
    "unicode": "🦙"
  },
  "giraffe": {
    "unicode": "🦒"
  },
  "elephant": {
    "unicode": "🐘"
  },
  "mammoth": {
    "unicode": "🦣"
  },
  "rhinoceros": {
    "unicode": "🦏"
  },
  "hippopotamus": {
    "unicode": "🦛"
  },
  "mouse face": {
    "unicode": "🐭"
  },
  "mouse": {
    "unicode": "🐁"
  },
  "rat": {
    "unicode": "🐀"
  },
  "hamster": {
    "unicode": "🐹"
  },
  "rabbit face": {
    "unicode": "🐰"
  },
  "rabbit": {
    "unicode": "🐇"
  },
  "chipmunk": {
    "unicode": "🐿️"
  },
  "beaver": {
    "unicode": "🦫"
  },
  "hedgehog": {
    "unicode": "🦔"
  },
  "bat": {
    "unicode": "🦇"
  },
  "bear": {
    "unicode": "🐻"
  },
  "polar bear": {
    "unicode": "🐻‍❄️"
  },
  "koala": {
    "unicode": "🐨"
  },
  "panda": {
    "unicode": "🐼"
  },
  "sloth": {
    "unicode": "🦥"
  },
  "otter": {
    "unicode": "🦦"
  },
  "skunk": {
    "unicode": "🦨"
  },
  "kangaroo": {
    "unicode": "🦘"
  },
  "badger": {
    "unicode": "🦡"
  },
  "paw prints": {
    "unicode": "🐾"
  },
  "turkey": {
    "unicode": "🦃"
  },
  "chicken": {
    "unicode": "🐔"
  },
  "rooster": {
    "unicode": "🐓"
  },
  "hatching chick": {
    "unicode": "🐣"
  },
  "baby chick": {
    "unicode": "🐤"
  },
  "front-facing baby chick": {
    "unicode": "🐥"
  },
  "bird": {
    "unicode": "🐦"
  },
  "penguin": {
    "unicode": "🐧"
  },
  "dove": {
    "unicode": "🕊️"
  },
  "eagle": {
    "unicode": "🦅"
  },
  "duck": {
    "unicode": "🦆"
  },
  "swan": {
    "unicode": "🦢"
  },
  "owl": {
    "unicode": "🦉"
  },
  "dodo": {
    "unicode": "🦤"
  },
  "feather": {
    "unicode": "🪶"
  },
  "flamingo": {
    "unicode": "🦩"
  },
  "peacock": {
    "unicode": "🦚"
  },
  "parrot": {
    "unicode": "🦜"
  },
  "frog": {
    "unicode": "🐸"
  },
  "crocodile": {
    "unicode": "🐊"
  },
  "turtle": {
    "unicode": "🐢"
  },
  "lizard": {
    "unicode": "🦎"
  },
  "snake": {
    "unicode": "🐍"
  },
  "dragon face": {
    "unicode": "🐲"
  },
  "dragon": {
    "unicode": "🐉"
  },
  "sauropod": {
    "unicode": "🦕"
  },
  "T-Rex": {
    "unicode": "🦖"
  },
  "spouting whale": {
    "unicode": "🐳"
  },
  "whale": {
    "unicode": "🐋"
  },
  "dolphin": {
    "unicode": "🐬"
  },
  "seal": {
    "unicode": "🦭"
  },
  "fish": {
    "unicode": "🐟"
  },
  "tropical fish": {
    "unicode": "🐠"
  },
  "blowfish": {
    "unicode": "🐡"
  },
  "shark": {
    "unicode": "🦈"
  },
  "octopus": {
    "unicode": "🐙"
  },
  "spiral shell": {
    "unicode": "🐚"
  },
  "snail": {
    "unicode": "🐌"
  },
  "butterfly": {
    "unicode": "🦋"
  },
  "bug": {
    "unicode": "🐛"
  },
  "ant": {
    "unicode": "🐜"
  },
  "honeybee": {
    "unicode": "🐝"
  },
  "beetle": {
    "unicode": "🪲"
  },
  "lady beetle": {
    "unicode": "🐞"
  },
  "cricket": {
    "unicode": "🦗"
  },
  "cockroach": {
    "unicode": "🪳"
  },
  "spider": {
    "unicode": "🕷️"
  },
  "spider web": {
    "unicode": "🕸️"
  },
  "scorpion": {
    "unicode": "🦂"
  },
  "mosquito": {
    "unicode": "🦟"
  },
  "fly": {
    "unicode": "🪰"
  },
  "worm": {
    "unicode": "🪱"
  },
  "microbe": {
    "unicode": "🦠"
  },
  "bouquet": {
    "unicode": "💐"
  },
  "cherry blossom": {
    "unicode": "🌸"
  },
  "white flower": {
    "unicode": "💮"
  },
  "rosette": {
    "unicode": "🏵️"
  },
  "rose": {
    "unicode": "🌹"
  },
  "wilted flower": {
    "unicode": "🥀"
  },
  "hibiscus": {
    "unicode": "🌺"
  },
  "sunflower": {
    "unicode": "🌻"
  },
  "blossom": {
    "unicode": "🌼"
  },
  "tulip": {
    "unicode": "🌷"
  },
  "seedling": {
    "unicode": "🌱"
  },
  "potted plant": {
    "unicode": "🪴"
  },
  "evergreen tree": {
    "unicode": "🌲"
  },
  "deciduous tree": {
    "unicode": "🌳"
  },
  "palm tree": {
    "unicode": "🌴"
  },
  "cactus": {
    "unicode": "🌵"
  },
  "sheaf of rice": {
    "unicode": "🌾"
  },
  "herb": {
    "unicode": "🌿"
  },
  "shamrock": {
    "unicode": "☘️"
  },
  "four leaf clover": {
    "unicode": "🍀"
  },
  "maple leaf": {
    "unicode": "🍁"
  },
  "fallen leaf": {
    "unicode": "🍂"
  },
  "leaf fluttering in wind": {
    "unicode": "🍃"
  },
  "grapes": {
    "unicode": "🍇"
  },
  "melon": {
    "unicode": "🍈"
  },
  "watermelon": {
    "unicode": "🍉"
  },
  "tangerine": {
    "unicode": "🍊"
  },
  "lemon": {
    "unicode": "🍋"
  },
  "banana": {
    "unicode": "🍌"
  },
  "pineapple": {
    "unicode": "🍍"
  },
  "mango": {
    "unicode": "🥭"
  },
  "red apple": {
    "unicode": "🍎"
  },
  "green apple": {
    "unicode": "🍏"
  },
  "pear": {
    "unicode": "🍐"
  },
  "peach": {
    "unicode": "🍑"
  },
  "cherries": {
    "unicode": "🍒"
  },
  "strawberry": {
    "unicode": "🍓"
  },
  "blueberries": {
    "unicode": "🫐"
  },
  "kiwi fruit": {
    "unicode": "🥝"
  },
  "tomato": {
    "unicode": "🍅"
  },
  "olive": {
    "unicode": "🫒"
  },
  "coconut": {
    "unicode": "🥥"
  },
  "avocado": {
    "unicode": "🥑"
  },
  "eggplant": {
    "unicode": "🍆"
  },
  "potato": {
    "unicode": "🥔"
  },
  "carrot": {
    "unicode": "🥕"
  },
  "ear of corn": {
    "unicode": "🌽"
  },
  "hot pepper": {
    "unicode": "🌶️"
  },
  "bell pepper": {
    "unicode": "🫑"
  },
  "cucumber": {
    "unicode": "🥒"
  },
  "leafy green": {
    "unicode": "🥬"
  },
  "broccoli": {
    "unicode": "🥦"
  },
  "garlic": {
    "unicode": "🧄"
  },
  "onion": {
    "unicode": "🧅"
  },
  "mushroom": {
    "unicode": "🍄"
  },
  "peanuts": {
    "unicode": "🥜"
  },
  "chestnut": {
    "unicode": "🌰"
  },
  "bread": {
    "unicode": "🍞"
  },
  "croissant": {
    "unicode": "🥐"
  },
  "baguette bread": {
    "unicode": "🥖"
  },
  "flatbread": {
    "unicode": "🫓"
  },
  "pretzel": {
    "unicode": "🥨"
  },
  "bagel": {
    "unicode": "🥯"
  },
  "pancakes": {
    "unicode": "🥞"
  },
  "waffle": {
    "unicode": "🧇"
  },
  "cheese wedge": {
    "unicode": "🧀"
  },
  "meat on bone": {
    "unicode": "🍖"
  },
  "poultry leg": {
    "unicode": "🍗"
  },
  "cut of meat": {
    "unicode": "🥩"
  },
  "bacon": {
    "unicode": "🥓"
  },
  "hamburger": {
    "unicode": "🍔"
  },
  "french fries": {
    "unicode": "🍟"
  },
  "pizza": {
    "unicode": "🍕"
  },
  "hot dog": {
    "unicode": "🌭"
  },
  "sandwich": {
    "unicode": "🥪"
  },
  "taco": {
    "unicode": "🌮"
  },
  "burrito": {
    "unicode": "🌯"
  },
  "tamale": {
    "unicode": "🫔"
  },
  "stuffed flatbread": {
    "unicode": "🥙"
  },
  "falafel": {
    "unicode": "🧆"
  },
  "egg": {
    "unicode": "🥚"
  },
  "cooking": {
    "unicode": "🍳"
  },
  "shallow pan of food": {
    "unicode": "🥘"
  },
  "pot of food": {
    "unicode": "🍲"
  },
  "fondue": {
    "unicode": "🫕"
  },
  "bowl with spoon": {
    "unicode": "🥣"
  },
  "green salad": {
    "unicode": "🥗"
  },
  "popcorn": {
    "unicode": "🍿"
  },
  "butter": {
    "unicode": "🧈"
  },
  "salt": {
    "unicode": "🧂"
  },
  "canned food": {
    "unicode": "🥫"
  },
  "bento box": {
    "unicode": "🍱"
  },
  "rice cracker": {
    "unicode": "🍘"
  },
  "rice ball": {
    "unicode": "🍙"
  },
  "cooked rice": {
    "unicode": "🍚"
  },
  "curry rice": {
    "unicode": "🍛"
  },
  "steaming bowl": {
    "unicode": "🍜"
  },
  "spaghetti": {
    "unicode": "🍝"
  },
  "roasted sweet potato": {
    "unicode": "🍠"
  },
  "oden": {
    "unicode": "🍢"
  },
  "sushi": {
    "unicode": "🍣"
  },
  "fried shrimp": {
    "unicode": "🍤"
  },
  "fish cake with swirl": {
    "unicode": "🍥"
  },
  "moon cake": {
    "unicode": "🥮"
  },
  "dango": {
    "unicode": "🍡"
  },
  "dumpling": {
    "unicode": "🥟"
  },
  "fortune cookie": {
    "unicode": "🥠"
  },
  "takeout box": {
    "unicode": "🥡"
  },
  "crab": {
    "unicode": "🦀"
  },
  "lobster": {
    "unicode": "🦞"
  },
  "shrimp": {
    "unicode": "🦐"
  },
  "squid": {
    "unicode": "🦑"
  },
  "oyster": {
    "unicode": "🦪"
  },
  "soft ice cream": {
    "unicode": "🍦"
  },
  "shaved ice": {
    "unicode": "🍧"
  },
  "ice cream": {
    "unicode": "🍨"
  },
  "doughnut": {
    "unicode": "🍩"
  },
  "cookie": {
    "unicode": "🍪"
  },
  "birthday cake": {
    "unicode": "🎂"
  },
  "shortcake": {
    "unicode": "🍰"
  },
  "cupcake": {
    "unicode": "🧁"
  },
  "pie": {
    "unicode": "🥧"
  },
  "chocolate bar": {
    "unicode": "🍫"
  },
  "candy": {
    "unicode": "🍬"
  },
  "lollipop": {
    "unicode": "🍭"
  },
  "custard": {
    "unicode": "🍮"
  },
  "honey pot": {
    "unicode": "🍯"
  },
  "baby bottle": {
    "unicode": "🍼"
  },
  "glass of milk": {
    "unicode": "🥛"
  },
  "hot beverage": {
    "unicode": "☕"
  },
  "teapot": {
    "unicode": "🫖"
  },
  "teacup without handle": {
    "unicode": "🍵"
  },
  "sake": {
    "unicode": "🍶"
  },
  "bottle with popping cork": {
    "unicode": "🍾"
  },
  "wine glass": {
    "unicode": "🍷"
  },
  "cocktail glass": {
    "unicode": "🍸"
  },
  "tropical drink": {
    "unicode": "🍹"
  },
  "beer mug": {
    "unicode": "🍺"
  },
  "clinking beer mugs": {
    "unicode": "🍻"
  },
  "clinking glasses": {
    "unicode": "🥂"
  },
  "tumbler glass": {
    "unicode": "🥃"
  },
  "cup with straw": {
    "unicode": "🥤"
  },
  "bubble tea": {
    "unicode": "🧋"
  },
  "beverage box": {
    "unicode": "🧃"
  },
  "mate": {
    "unicode": "🧉"
  },
  "ice": {
    "unicode": "🧊"
  },
  "chopsticks": {
    "unicode": "🥢"
  },
  "fork and knife with plate": {
    "unicode": "🍽️"
  },
  "fork and knife": {
    "unicode": "🍴"
  },
  "spoon": {
    "unicode": "🥄"
  },
  "kitchen knife": {
    "unicode": "🔪"
  },
  "amphora": {
    "unicode": "🏺"
  },
  "globe showing Europe-Africa": {
    "unicode": "🌍"
  },
  "globe showing Americas": {
    "unicode": "🌎"
  },
  "globe showing Asia-Australia": {
    "unicode": "🌏"
  },
  "globe with meridians": {
    "unicode": "🌐"
  },
  "world map": {
    "unicode": "🗺️"
  },
  "map of Japan": {
    "unicode": "🗾"
  },
  "compass": {
    "unicode": "🧭"
  },
  "snow-capped mountain": {
    "unicode": "🏔️"
  },
  "mountain": {
    "unicode": "⛰️"
  },
  "volcano": {
    "unicode": "🌋"
  },
  "mount fuji": {
    "unicode": "🗻"
  },
  "camping": {
    "unicode": "🏕️"
  },
  "beach with umbrella": {
    "unicode": "🏖️"
  },
  "desert": {
    "unicode": "🏜️"
  },
  "desert island": {
    "unicode": "🏝️"
  },
  "national park": {
    "unicode": "🏞️"
  },
  "stadium": {
    "unicode": "🏟️"
  },
  "classical building": {
    "unicode": "🏛️"
  },
  "building construction": {
    "unicode": "🏗️"
  },
  "brick": {
    "unicode": "🧱"
  },
  "rock": {
    "unicode": "🪨"
  },
  "wood": {
    "unicode": "🪵"
  },
  "hut": {
    "unicode": "🛖"
  },
  "houses": {
    "unicode": "🏘️"
  },
  "derelict house": {
    "unicode": "🏚️"
  },
  "house": {
    "unicode": "🏠"
  },
  "house with garden": {
    "unicode": "🏡"
  },
  "office building": {
    "unicode": "🏢"
  },
  "Japanese post office": {
    "unicode": "🏣"
  },
  "post office": {
    "unicode": "🏤"
  },
  "hospital": {
    "unicode": "🏥"
  },
  "bank": {
    "unicode": "🏦"
  },
  "hotel": {
    "unicode": "🏨"
  },
  "love hotel": {
    "unicode": "🏩"
  },
  "convenience store": {
    "unicode": "🏪"
  },
  "school": {
    "unicode": "🏫"
  },
  "department store": {
    "unicode": "🏬"
  },
  "factory": {
    "unicode": "🏭"
  },
  "Japanese castle": {
    "unicode": "🏯"
  },
  "castle": {
    "unicode": "🏰"
  },
  "wedding": {
    "unicode": "💒"
  },
  "Tokyo tower": {
    "unicode": "🗼"
  },
  "Statue of Liberty": {
    "unicode": "🗽"
  },
  "church": {
    "unicode": "⛪"
  },
  "mosque": {
    "unicode": "🕌"
  },
  "hindu temple": {
    "unicode": "🛕"
  },
  "synagogue": {
    "unicode": "🕍"
  },
  "shinto shrine": {
    "unicode": "⛩️"
  },
  "kaaba": {
    "unicode": "🕋"
  },
  "fountain": {
    "unicode": "⛲"
  },
  "tent": {
    "unicode": "⛺"
  },
  "foggy": {
    "unicode": "🌁"
  },
  "night with stars": {
    "unicode": "🌃"
  },
  "cityscape": {
    "unicode": "🏙️"
  },
  "sunrise over mountains": {
    "unicode": "🌄"
  },
  "sunrise": {
    "unicode": "🌅"
  },
  "cityscape at dusk": {
    "unicode": "🌆"
  },
  "sunset": {
    "unicode": "🌇"
  },
  "bridge at night": {
    "unicode": "🌉"
  },
  "hot springs": {
    "unicode": "♨️"
  },
  "carousel horse": {
    "unicode": "🎠"
  },
  "ferris wheel": {
    "unicode": "🎡"
  },
  "roller coaster": {
    "unicode": "🎢"
  },
  "barber pole": {
    "unicode": "💈"
  },
  "circus tent": {
    "unicode": "🎪"
  },
  "locomotive": {
    "unicode": "🚂"
  },
  "railway car": {
    "unicode": "🚃"
  },
  "high-speed train": {
    "unicode": "🚄"
  },
  "bullet train": {
    "unicode": "🚅"
  },
  "train": {
    "unicode": "🚆"
  },
  "metro": {
    "unicode": "🚇"
  },
  "light rail": {
    "unicode": "🚈"
  },
  "station": {
    "unicode": "🚉"
  },
  "tram": {
    "unicode": "🚊"
  },
  "monorail": {
    "unicode": "🚝"
  },
  "mountain railway": {
    "unicode": "🚞"
  },
  "tram car": {
    "unicode": "🚋"
  },
  "bus": {
    "unicode": "🚌"
  },
  "oncoming bus": {
    "unicode": "🚍"
  },
  "trolleybus": {
    "unicode": "🚎"
  },
  "minibus": {
    "unicode": "🚐"
  },
  "ambulance": {
    "unicode": "🚑"
  },
  "fire engine": {
    "unicode": "🚒"
  },
  "police car": {
    "unicode": "🚓"
  },
  "oncoming police car": {
    "unicode": "🚔"
  },
  "taxi": {
    "unicode": "🚕"
  },
  "oncoming taxi": {
    "unicode": "🚖"
  },
  "automobile": {
    "unicode": "🚗"
  },
  "oncoming automobile": {
    "unicode": "🚘"
  },
  "sport utility vehicle": {
    "unicode": "🚙"
  },
  "pickup truck": {
    "unicode": "🛻"
  },
  "delivery truck": {
    "unicode": "🚚"
  },
  "articulated lorry": {
    "unicode": "🚛"
  },
  "tractor": {
    "unicode": "🚜"
  },
  "racing car": {
    "unicode": "🏎️"
  },
  "motorcycle": {
    "unicode": "🏍️"
  },
  "motor scooter": {
    "unicode": "🛵"
  },
  "manual wheelchair": {
    "unicode": "🦽"
  },
  "motorized wheelchair": {
    "unicode": "🦼"
  },
  "auto rickshaw": {
    "unicode": "🛺"
  },
  "bicycle": {
    "unicode": "🚲"
  },
  "kick scooter": {
    "unicode": "🛴"
  },
  "skateboard": {
    "unicode": "🛹"
  },
  "roller skate": {
    "unicode": "🛼"
  },
  "bus stop": {
    "unicode": "🚏"
  },
  "motorway": {
    "unicode": "🛣️"
  },
  "railway track": {
    "unicode": "🛤️"
  },
  "oil drum": {
    "unicode": "🛢️"
  },
  "fuel pump": {
    "unicode": "⛽"
  },
  "police car light": {
    "unicode": "🚨"
  },
  "horizontal traffic light": {
    "unicode": "🚥"
  },
  "vertical traffic light": {
    "unicode": "🚦"
  },
  "stop sign": {
    "unicode": "🛑"
  },
  "construction": {
    "unicode": "🚧"
  },
  "anchor": {
    "unicode": "⚓"
  },
  "sailboat": {
    "unicode": "⛵"
  },
  "canoe": {
    "unicode": "🛶"
  },
  "speedboat": {
    "unicode": "🚤"
  },
  "passenger ship": {
    "unicode": "🛳️"
  },
  "ferry": {
    "unicode": "⛴️"
  },
  "motor boat": {
    "unicode": "🛥️"
  },
  "ship": {
    "unicode": "🚢"
  },
  "airplane": {
    "unicode": "✈️"
  },
  "small airplane": {
    "unicode": "🛩️"
  },
  "airplane departure": {
    "unicode": "🛫"
  },
  "airplane arrival": {
    "unicode": "🛬"
  },
  "parachute": {
    "unicode": "🪂"
  },
  "seat": {
    "unicode": "💺"
  },
  "helicopter": {
    "unicode": "🚁"
  },
  "suspension railway": {
    "unicode": "🚟"
  },
  "mountain cableway": {
    "unicode": "🚠"
  },
  "aerial tramway": {
    "unicode": "🚡"
  },
  "satellite": {
    "unicode": "🛰️"
  },
  "rocket": {
    "unicode": "🚀"
  },
  "flying saucer": {
    "unicode": "🛸"
  },
  "bellhop bell": {
    "unicode": "🛎️"
  },
  "luggage": {
    "unicode": "🧳"
  },
  "hourglass done": {
    "unicode": "⌛"
  },
  "hourglass not done": {
    "unicode": "⏳"
  },
  "watch": {
    "unicode": "⌚"
  },
  "alarm clock": {
    "unicode": "⏰"
  },
  "stopwatch": {
    "unicode": "⏱️"
  },
  "timer clock": {
    "unicode": "⏲️"
  },
  "mantelpiece clock": {
    "unicode": "🕰️"
  },
  "twelve o’clock": {
    "unicode": "🕛"
  },
  "twelve-thirty": {
    "unicode": "🕧"
  },
  "one o’clock": {
    "unicode": "🕐"
  },
  "one-thirty": {
    "unicode": "🕜"
  },
  "two o’clock": {
    "unicode": "🕑"
  },
  "two-thirty": {
    "unicode": "🕝"
  },
  "three o’clock": {
    "unicode": "🕒"
  },
  "three-thirty": {
    "unicode": "🕞"
  },
  "four o’clock": {
    "unicode": "🕓"
  },
  "four-thirty": {
    "unicode": "🕟"
  },
  "five o’clock": {
    "unicode": "🕔"
  },
  "five-thirty": {
    "unicode": "🕠"
  },
  "six o’clock": {
    "unicode": "🕕"
  },
  "six-thirty": {
    "unicode": "🕡"
  },
  "seven o’clock": {
    "unicode": "🕖"
  },
  "seven-thirty": {
    "unicode": "🕢"
  },
  "eight o’clock": {
    "unicode": "🕗"
  },
  "eight-thirty": {
    "unicode": "🕣"
  },
  "nine o’clock": {
    "unicode": "🕘"
  },
  "nine-thirty": {
    "unicode": "🕤"
  },
  "ten o’clock": {
    "unicode": "🕙"
  },
  "ten-thirty": {
    "unicode": "🕥"
  },
  "eleven o’clock": {
    "unicode": "🕚"
  },
  "eleven-thirty": {
    "unicode": "🕦"
  },
  "new moon": {
    "unicode": "🌑"
  },
  "waxing crescent moon": {
    "unicode": "🌒"
  },
  "first quarter moon": {
    "unicode": "🌓"
  },
  "waxing gibbous moon": {
    "unicode": "🌔"
  },
  "full moon": {
    "unicode": "🌕"
  },
  "waning gibbous moon": {
    "unicode": "🌖"
  },
  "last quarter moon": {
    "unicode": "🌗"
  },
  "waning crescent moon": {
    "unicode": "🌘"
  },
  "crescent moon": {
    "unicode": "🌙"
  },
  "new moon face": {
    "unicode": "🌚"
  },
  "first quarter moon face": {
    "unicode": "🌛"
  },
  "last quarter moon face": {
    "unicode": "🌜"
  },
  "thermometer": {
    "unicode": "🌡️"
  },
  "sun": {
    "unicode": "☀️"
  },
  "full moon face": {
    "unicode": "🌝"
  },
  "sun with face": {
    "unicode": "🌞"
  },
  "ringed planet": {
    "unicode": "🪐"
  },
  "star": {
    "unicode": "⭐"
  },
  "glowing star": {
    "unicode": "🌟"
  },
  "shooting star": {
    "unicode": "🌠"
  },
  "milky way": {
    "unicode": "🌌"
  },
  "cloud": {
    "unicode": "☁️"
  },
  "sun behind cloud": {
    "unicode": "⛅"
  },
  "cloud with lightning and rain": {
    "unicode": "⛈️"
  },
  "sun behind small cloud": {
    "unicode": "🌤️"
  },
  "sun behind large cloud": {
    "unicode": "🌥️"
  },
  "sun behind rain cloud": {
    "unicode": "🌦️"
  },
  "cloud with rain": {
    "unicode": "🌧️"
  },
  "cloud with snow": {
    "unicode": "🌨️"
  },
  "cloud with lightning": {
    "unicode": "🌩️"
  },
  "tornado": {
    "unicode": "🌪️"
  },
  "fog": {
    "unicode": "🌫️"
  },
  "wind face": {
    "unicode": "🌬️"
  },
  "cyclone": {
    "unicode": "🌀"
  },
  "rainbow": {
    "unicode": "🌈"
  },
  "closed umbrella": {
    "unicode": "🌂"
  },
  "umbrella": {
    "unicode": "☂️"
  },
  "umbrella with rain drops": {
    "unicode": "☔"
  },
  "umbrella on ground": {
    "unicode": "⛱️"
  },
  "high voltage": {
    "unicode": "⚡"
  },
  "snowflake": {
    "unicode": "❄️"
  },
  "snowman": {
    "unicode": "☃️"
  },
  "snowman without snow": {
    "unicode": "⛄"
  },
  "comet": {
    "unicode": "☄️"
  },
  "fire": {
    "unicode": "🔥"
  },
  "droplet": {
    "unicode": "💧"
  },
  "water wave": {
    "unicode": "🌊"
  },
  "jack-o-lantern": {
    "unicode": "🎃"
  },
  "Christmas tree": {
    "unicode": "🎄"
  },
  "fireworks": {
    "unicode": "🎆"
  },
  "sparkler": {
    "unicode": "🎇"
  },
  "firecracker": {
    "unicode": "🧨"
  },
  "sparkles": {
    "unicode": "✨"
  },
  "balloon": {
    "unicode": "🎈"
  },
  "party popper": {
    "unicode": "🎉"
  },
  "confetti ball": {
    "unicode": "🎊"
  },
  "tanabata tree": {
    "unicode": "🎋"
  },
  "pine decoration": {
    "unicode": "🎍"
  },
  "Japanese dolls": {
    "unicode": "🎎"
  },
  "carp streamer": {
    "unicode": "🎏"
  },
  "wind chime": {
    "unicode": "🎐"
  },
  "moon viewing ceremony": {
    "unicode": "🎑"
  },
  "red envelope": {
    "unicode": "🧧"
  },
  "ribbon": {
    "unicode": "🎀"
  },
  "wrapped gift": {
    "unicode": "🎁"
  },
  "reminder ribbon": {
    "unicode": "🎗️"
  },
  "admission tickets": {
    "unicode": "🎟️"
  },
  "ticket": {
    "unicode": "🎫"
  },
  "military medal": {
    "unicode": "🎖️"
  },
  "trophy": {
    "unicode": "🏆"
  },
  "sports medal": {
    "unicode": "🏅"
  },
  "1st place medal": {
    "unicode": "🥇"
  },
  "2nd place medal": {
    "unicode": "🥈"
  },
  "3rd place medal": {
    "unicode": "🥉"
  },
  "soccer ball": {
    "unicode": "⚽"
  },
  "baseball": {
    "unicode": "⚾"
  },
  "softball": {
    "unicode": "🥎"
  },
  "basketball": {
    "unicode": "🏀"
  },
  "volleyball": {
    "unicode": "🏐"
  },
  "american football": {
    "unicode": "🏈"
  },
  "rugby football": {
    "unicode": "🏉"
  },
  "tennis": {
    "unicode": "🎾"
  },
  "flying disc": {
    "unicode": "🥏"
  },
  "bowling": {
    "unicode": "🎳"
  },
  "cricket game": {
    "unicode": "🏏"
  },
  "field hockey": {
    "unicode": "🏑"
  },
  "ice hockey": {
    "unicode": "🏒"
  },
  "lacrosse": {
    "unicode": "🥍"
  },
  "ping pong": {
    "unicode": "🏓"
  },
  "badminton": {
    "unicode": "🏸"
  },
  "boxing glove": {
    "unicode": "🥊"
  },
  "martial arts uniform": {
    "unicode": "🥋"
  },
  "goal net": {
    "unicode": "🥅"
  },
  "flag in hole": {
    "unicode": "⛳"
  },
  "ice skate": {
    "unicode": "⛸️"
  },
  "fishing pole": {
    "unicode": "🎣"
  },
  "diving mask": {
    "unicode": "🤿"
  },
  "running shirt": {
    "unicode": "🎽"
  },
  "skis": {
    "unicode": "🎿"
  },
  "sled": {
    "unicode": "🛷"
  },
  "curling stone": {
    "unicode": "🥌"
  },
  "direct hit": {
    "unicode": "🎯"
  },
  "yo-yo": {
    "unicode": "🪀"
  },
  "kite": {
    "unicode": "🪁"
  },
  "pool 8 ball": {
    "unicode": "🎱"
  },
  "crystal ball": {
    "unicode": "🔮"
  },
  "magic wand": {
    "unicode": "🪄"
  },
  "nazar amulet": {
    "unicode": "🧿"
  },
  "video game": {
    "unicode": "🎮"
  },
  "joystick": {
    "unicode": "🕹️"
  },
  "slot machine": {
    "unicode": "🎰"
  },
  "game die": {
    "unicode": "🎲"
  },
  "puzzle piece": {
    "unicode": "🧩"
  },
  "teddy bear": {
    "unicode": "🧸"
  },
  "piñata": {
    "unicode": "🪅"
  },
  "nesting dolls": {
    "unicode": "🪆"
  },
  "spade suit": {
    "unicode": "♠️"
  },
  "heart suit": {
    "unicode": "♥️"
  },
  "diamond suit": {
    "unicode": "♦️"
  },
  "club suit": {
    "unicode": "♣️"
  },
  "chess pawn": {
    "unicode": "♟️"
  },
  "joker": {
    "unicode": "🃏"
  },
  "mahjong red dragon": {
    "unicode": "🀄"
  },
  "flower playing cards": {
    "unicode": "🎴"
  },
  "performing arts": {
    "unicode": "🎭"
  },
  "framed picture": {
    "unicode": "🖼️"
  },
  "artist palette": {
    "unicode": "🎨"
  },
  "thread": {
    "unicode": "🧵"
  },
  "sewing needle": {
    "unicode": "🪡"
  },
  "yarn": {
    "unicode": "🧶"
  },
  "knot": {
    "unicode": "🪢"
  },
  "glasses": {
    "unicode": "👓"
  },
  "sunglasses": {
    "unicode": "🕶️"
  },
  "goggles": {
    "unicode": "🥽"
  },
  "lab coat": {
    "unicode": "🥼"
  },
  "safety vest": {
    "unicode": "🦺"
  },
  "necktie": {
    "unicode": "👔"
  },
  "t-shirt": {
    "unicode": "👕"
  },
  "jeans": {
    "unicode": "👖"
  },
  "scarf": {
    "unicode": "🧣"
  },
  "gloves": {
    "unicode": "🧤"
  },
  "coat": {
    "unicode": "🧥"
  },
  "socks": {
    "unicode": "🧦"
  },
  "dress": {
    "unicode": "👗"
  },
  "kimono": {
    "unicode": "👘"
  },
  "sari": {
    "unicode": "🥻"
  },
  "one-piece swimsuit": {
    "unicode": "🩱"
  },
  "briefs": {
    "unicode": "🩲"
  },
  "shorts": {
    "unicode": "🩳"
  },
  "bikini": {
    "unicode": "👙"
  },
  "woman’s clothes": {
    "unicode": "👚"
  },
  "purse": {
    "unicode": "👛"
  },
  "handbag": {
    "unicode": "👜"
  },
  "clutch bag": {
    "unicode": "👝"
  },
  "shopping bags": {
    "unicode": "🛍️"
  },
  "backpack": {
    "unicode": "🎒"
  },
  "thong sandal": {
    "unicode": "🩴"
  },
  "man’s shoe": {
    "unicode": "👞"
  },
  "running shoe": {
    "unicode": "👟"
  },
  "hiking boot": {
    "unicode": "🥾"
  },
  "flat shoe": {
    "unicode": "🥿"
  },
  "high-heeled shoe": {
    "unicode": "👠"
  },
  "woman’s sandal": {
    "unicode": "👡"
  },
  "ballet shoes": {
    "unicode": "🩰"
  },
  "woman’s boot": {
    "unicode": "👢"
  },
  "crown": {
    "unicode": "👑"
  },
  "woman’s hat": {
    "unicode": "👒"
  },
  "top hat": {
    "unicode": "🎩"
  },
  "graduation cap": {
    "unicode": "🎓"
  },
  "billed cap": {
    "unicode": "🧢"
  },
  "military helmet": {
    "unicode": "🪖"
  },
  "rescue worker’s helmet": {
    "unicode": "⛑️"
  },
  "prayer beads": {
    "unicode": "📿"
  },
  "lipstick": {
    "unicode": "💄"
  },
  "ring": {
    "unicode": "💍"
  },
  "gem stone": {
    "unicode": "💎"
  },
  "muted speaker": {
    "unicode": "🔇"
  },
  "speaker low volume": {
    "unicode": "🔈"
  },
  "speaker medium volume": {
    "unicode": "🔉"
  },
  "speaker high volume": {
    "unicode": "🔊"
  },
  "loudspeaker": {
    "unicode": "📢"
  },
  "megaphone": {
    "unicode": "📣"
  },
  "postal horn": {
    "unicode": "📯"
  },
  "bell": {
    "unicode": "🔔"
  },
  "bell with slash": {
    "unicode": "🔕"
  },
  "musical score": {
    "unicode": "🎼"
  },
  "musical note": {
    "unicode": "🎵"
  },
  "musical notes": {
    "unicode": "🎶"
  },
  "studio microphone": {
    "unicode": "🎙️"
  },
  "level slider": {
    "unicode": "🎚️"
  },
  "control knobs": {
    "unicode": "🎛️"
  },
  "microphone": {
    "unicode": "🎤"
  },
  "headphone": {
    "unicode": "🎧"
  },
  "radio": {
    "unicode": "📻"
  },
  "saxophone": {
    "unicode": "🎷"
  },
  "accordion": {
    "unicode": "🪗"
  },
  "guitar": {
    "unicode": "🎸"
  },
  "musical keyboard": {
    "unicode": "🎹"
  },
  "trumpet": {
    "unicode": "🎺"
  },
  "violin": {
    "unicode": "🎻"
  },
  "banjo": {
    "unicode": "🪕"
  },
  "drum": {
    "unicode": "🥁"
  },
  "long drum": {
    "unicode": "🪘"
  },
  "mobile phone": {
    "unicode": "📱"
  },
  "mobile phone with arrow": {
    "unicode": "📲"
  },
  "telephone": {
    "unicode": "☎️"
  },
  "telephone receiver": {
    "unicode": "📞"
  },
  "pager": {
    "unicode": "📟"
  },
  "fax machine": {
    "unicode": "📠"
  },
  "battery": {
    "unicode": "🔋"
  },
  "electric plug": {
    "unicode": "🔌"
  },
  "laptop": {
    "unicode": "💻"
  },
  "desktop computer": {
    "unicode": "🖥️"
  },
  "printer": {
    "unicode": "🖨️"
  },
  "keyboard": {
    "unicode": "⌨️"
  },
  "computer mouse": {
    "unicode": "🖱️"
  },
  "trackball": {
    "unicode": "🖲️"
  },
  "computer disk": {
    "unicode": "💽"
  },
  "floppy disk": {
    "unicode": "💾"
  },
  "optical disk": {
    "unicode": "💿"
  },
  "dvd": {
    "unicode": "📀"
  },
  "abacus": {
    "unicode": "🧮"
  },
  "movie camera": {
    "unicode": "🎥"
  },
  "film frames": {
    "unicode": "🎞️"
  },
  "film projector": {
    "unicode": "📽️"
  },
  "clapper board": {
    "unicode": "🎬"
  },
  "television": {
    "unicode": "📺"
  },
  "camera": {
    "unicode": "📷"
  },
  "camera with flash": {
    "unicode": "📸"
  },
  "video camera": {
    "unicode": "📹"
  },
  "videocassette": {
    "unicode": "📼"
  },
  "magnifying glass tilted left": {
    "unicode": "🔍"
  },
  "magnifying glass tilted right": {
    "unicode": "🔎"
  },
  "candle": {
    "unicode": "🕯️"
  },
  "light bulb": {
    "unicode": "💡"
  },
  "flashlight": {
    "unicode": "🔦"
  },
  "red paper lantern": {
    "unicode": "🏮"
  },
  "diya lamp": {
    "unicode": "🪔"
  },
  "notebook with decorative cover": {
    "unicode": "📔"
  },
  "closed book": {
    "unicode": "📕"
  },
  "open book": {
    "unicode": "📖"
  },
  "green book": {
    "unicode": "📗"
  },
  "blue book": {
    "unicode": "📘"
  },
  "orange book": {
    "unicode": "📙"
  },
  "books": {
    "unicode": "📚"
  },
  "notebook": {
    "unicode": "📓"
  },
  "ledger": {
    "unicode": "📒"
  },
  "page with curl": {
    "unicode": "📃"
  },
  "scroll": {
    "unicode": "📜"
  },
  "page facing up": {
    "unicode": "📄"
  },
  "newspaper": {
    "unicode": "📰"
  },
  "rolled-up newspaper": {
    "unicode": "🗞️"
  },
  "bookmark tabs": {
    "unicode": "📑"
  },
  "bookmark": {
    "unicode": "🔖"
  },
  "label": {
    "unicode": "🏷️"
  },
  "money bag": {
    "unicode": "💰"
  },
  "coin": {
    "unicode": "🪙"
  },
  "yen banknote": {
    "unicode": "💴"
  },
  "dollar banknote": {
    "unicode": "💵"
  },
  "euro banknote": {
    "unicode": "💶"
  },
  "pound banknote": {
    "unicode": "💷"
  },
  "money with wings": {
    "unicode": "💸"
  },
  "credit card": {
    "unicode": "💳"
  },
  "receipt": {
    "unicode": "🧾"
  },
  "chart increasing with yen": {
    "unicode": "💹"
  },
  "envelope": {
    "unicode": "✉️"
  },
  "e-mail": {
    "unicode": "📧"
  },
  "incoming envelope": {
    "unicode": "📨"
  },
  "envelope with arrow": {
    "unicode": "📩"
  },
  "outbox tray": {
    "unicode": "📤"
  },
  "inbox tray": {
    "unicode": "📥"
  },
  "package": {
    "unicode": "📦"
  },
  "closed mailbox with raised flag": {
    "unicode": "📫"
  },
  "closed mailbox with lowered flag": {
    "unicode": "📪"
  },
  "open mailbox with raised flag": {
    "unicode": "📬"
  },
  "open mailbox with lowered flag": {
    "unicode": "📭"
  },
  "postbox": {
    "unicode": "📮"
  },
  "ballot box with ballot": {
    "unicode": "🗳️"
  },
  "pencil": {
    "unicode": "✏️"
  },
  "black nib": {
    "unicode": "✒️"
  },
  "fountain pen": {
    "unicode": "🖋️"
  },
  "pen": {
    "unicode": "🖊️"
  },
  "paintbrush": {
    "unicode": "🖌️"
  },
  "crayon": {
    "unicode": "🖍️"
  },
  "memo": {
    "unicode": "📝"
  },
  "briefcase": {
    "unicode": "💼"
  },
  "file folder": {
    "unicode": "📁"
  },
  "open file folder": {
    "unicode": "📂"
  },
  "card index dividers": {
    "unicode": "🗂️"
  },
  "calendar": {
    "unicode": "📅"
  },
  "tear-off calendar": {
    "unicode": "📆"
  },
  "spiral notepad": {
    "unicode": "🗒️"
  },
  "spiral calendar": {
    "unicode": "🗓️"
  },
  "card index": {
    "unicode": "📇"
  },
  "chart increasing": {
    "unicode": "📈"
  },
  "chart decreasing": {
    "unicode": "📉"
  },
  "bar chart": {
    "unicode": "📊"
  },
  "clipboard": {
    "unicode": "📋"
  },
  "pushpin": {
    "unicode": "📌"
  },
  "round pushpin": {
    "unicode": "📍"
  },
  "paperclip": {
    "unicode": "📎"
  },
  "linked paperclips": {
    "unicode": "🖇️"
  },
  "straight ruler": {
    "unicode": "📏"
  },
  "triangular ruler": {
    "unicode": "📐"
  },
  "scissors": {
    "unicode": "✂️"
  },
  "card file box": {
    "unicode": "🗃️"
  },
  "file cabinet": {
    "unicode": "🗄️"
  },
  "wastebasket": {
    "unicode": "🗑️"
  },
  "locked": {
    "unicode": "🔒"
  },
  "unlocked": {
    "unicode": "🔓"
  },
  "locked with pen": {
    "unicode": "🔏"
  },
  "locked with key": {
    "unicode": "🔐"
  },
  "key": {
    "unicode": "🔑"
  },
  "old key": {
    "unicode": "🗝️"
  },
  "hammer": {
    "unicode": "🔨"
  },
  "axe": {
    "unicode": "🪓"
  },
  "pick": {
    "unicode": "⛏️"
  },
  "hammer and pick": {
    "unicode": "⚒️"
  },
  "hammer and wrench": {
    "unicode": "🛠️"
  },
  "dagger": {
    "unicode": "🗡️"
  },
  "crossed swords": {
    "unicode": "⚔️"
  },
  "pistol": {
    "unicode": "🔫"
  },
  "boomerang": {
    "unicode": "🪃"
  },
  "bow and arrow": {
    "unicode": "🏹"
  },
  "shield": {
    "unicode": "🛡️"
  },
  "carpentry saw": {
    "unicode": "🪚"
  },
  "wrench": {
    "unicode": "🔧"
  },
  "screwdriver": {
    "unicode": "🪛"
  },
  "nut and bolt": {
    "unicode": "🔩"
  },
  "gear": {
    "unicode": "⚙️"
  },
  "clamp": {
    "unicode": "🗜️"
  },
  "balance scale": {
    "unicode": "⚖️"
  },
  "white cane": {
    "unicode": "🦯"
  },
  "link": {
    "unicode": "🔗"
  },
  "chains": {
    "unicode": "⛓️"
  },
  "hook": {
    "unicode": "🪝"
  },
  "toolbox": {
    "unicode": "🧰"
  },
  "magnet": {
    "unicode": "🧲"
  },
  "ladder": {
    "unicode": "🪜"
  },
  "alembic": {
    "unicode": "⚗️"
  },
  "test tube": {
    "unicode": "🧪"
  },
  "petri dish": {
    "unicode": "🧫"
  },
  "dna": {
    "unicode": "🧬"
  },
  "microscope": {
    "unicode": "🔬"
  },
  "telescope": {
    "unicode": "🔭"
  },
  "satellite antenna": {
    "unicode": "📡"
  },
  "syringe": {
    "unicode": "💉"
  },
  "drop of blood": {
    "unicode": "🩸"
  },
  "pill": {
    "unicode": "💊"
  },
  "adhesive bandage": {
    "unicode": "🩹"
  },
  "stethoscope": {
    "unicode": "🩺"
  },
  "door": {
    "unicode": "🚪"
  },
  "elevator": {
    "unicode": "🛗"
  },
  "mirror": {
    "unicode": "🪞"
  },
  "window": {
    "unicode": "🪟"
  },
  "bed": {
    "unicode": "🛏️"
  },
  "couch and lamp": {
    "unicode": "🛋️"
  },
  "chair": {
    "unicode": "🪑"
  },
  "toilet": {
    "unicode": "🚽"
  },
  "plunger": {
    "unicode": "🪠"
  },
  "shower": {
    "unicode": "🚿"
  },
  "bathtub": {
    "unicode": "🛁"
  },
  "mouse trap": {
    "unicode": "🪤"
  },
  "razor": {
    "unicode": "🪒"
  },
  "lotion bottle": {
    "unicode": "🧴"
  },
  "safety pin": {
    "unicode": "🧷"
  },
  "broom": {
    "unicode": "🧹"
  },
  "basket": {
    "unicode": "🧺"
  },
  "roll of paper": {
    "unicode": "🧻"
  },
  "bucket": {
    "unicode": "🪣"
  },
  "soap": {
    "unicode": "🧼"
  },
  "toothbrush": {
    "unicode": "🪥"
  },
  "sponge": {
    "unicode": "🧽"
  },
  "fire extinguisher": {
    "unicode": "🧯"
  },
  "shopping cart": {
    "unicode": "🛒"
  },
  "cigarette": {
    "unicode": "🚬"
  },
  "coffin": {
    "unicode": "⚰️"
  },
  "headstone": {
    "unicode": "🪦"
  },
  "funeral urn": {
    "unicode": "⚱️"
  },
  "moai": {
    "unicode": "🗿"
  },
  "placard": {
    "unicode": "🪧"
  },
  "ATM sign": {
    "unicode": "🏧"
  },
  "litter in bin sign": {
    "unicode": "🚮"
  },
  "potable water": {
    "unicode": "🚰"
  },
  "wheelchair symbol": {
    "unicode": "♿"
  },
  "men’s room": {
    "unicode": "🚹"
  },
  "women’s room": {
    "unicode": "🚺"
  },
  "restroom": {
    "unicode": "🚻"
  },
  "baby symbol": {
    "unicode": "🚼"
  },
  "water closet": {
    "unicode": "🚾"
  },
  "passport control": {
    "unicode": "🛂"
  },
  "customs": {
    "unicode": "🛃"
  },
  "baggage claim": {
    "unicode": "🛄"
  },
  "left luggage": {
    "unicode": "🛅"
  },
  "warning": {
    "unicode": "⚠️"
  },
  "children crossing": {
    "unicode": "🚸"
  },
  "no entry": {
    "unicode": "⛔"
  },
  "prohibited": {
    "unicode": "🚫"
  },
  "no bicycles": {
    "unicode": "🚳"
  },
  "no smoking": {
    "unicode": "🚭"
  },
  "no littering": {
    "unicode": "🚯"
  },
  "non-potable water": {
    "unicode": "🚱"
  },
  "no pedestrians": {
    "unicode": "🚷"
  },
  "no mobile phones": {
    "unicode": "📵"
  },
  "no one under eighteen": {
    "unicode": "🔞"
  },
  "radioactive": {
    "unicode": "☢️"
  },
  "biohazard": {
    "unicode": "☣️"
  },
  "up arrow": {
    "unicode": "⬆️"
  },
  "up-right arrow": {
    "unicode": "↗️"
  },
  "right arrow": {
    "unicode": "➡️"
  },
  "down-right arrow": {
    "unicode": "↘️"
  },
  "down arrow": {
    "unicode": "⬇️"
  },
  "down-left arrow": {
    "unicode": "↙️"
  },
  "left arrow": {
    "unicode": "⬅️"
  },
  "up-left arrow": {
    "unicode": "↖️"
  },
  "up-down arrow": {
    "unicode": "↕️"
  },
  "left-right arrow": {
    "unicode": "↔️"
  },
  "right arrow curving left": {
    "unicode": "↩️"
  },
  "left arrow curving right": {
    "unicode": "↪️"
  },
  "right arrow curving up": {
    "unicode": "⤴️"
  },
  "right arrow curving down": {
    "unicode": "⤵️"
  },
  "clockwise vertical arrows": {
    "unicode": "🔃"
  },
  "counterclockwise arrows button": {
    "unicode": "🔄"
  },
  "BACK arrow": {
    "unicode": "🔙"
  },
  "END arrow": {
    "unicode": "🔚"
  },
  "ON! arrow": {
    "unicode": "🔛"
  },
  "SOON arrow": {
    "unicode": "🔜"
  },
  "TOP arrow": {
    "unicode": "🔝"
  },
  "place of worship": {
    "unicode": "🛐"
  },
  "atom symbol": {
    "unicode": "⚛️"
  },
  "om": {
    "unicode": "🕉️"
  },
  "star of David": {
    "unicode": "✡️"
  },
  "wheel of dharma": {
    "unicode": "☸️"
  },
  "yin yang": {
    "unicode": "☯️"
  },
  "latin cross": {
    "unicode": "✝️"
  },
  "orthodox cross": {
    "unicode": "☦️"
  },
  "star and crescent": {
    "unicode": "☪️"
  },
  "peace symbol": {
    "unicode": "☮️"
  },
  "menorah": {
    "unicode": "🕎"
  },
  "dotted six-pointed star": {
    "unicode": "🔯"
  },
  "Aries": {
    "unicode": "♈"
  },
  "Taurus": {
    "unicode": "♉"
  },
  "Gemini": {
    "unicode": "♊"
  },
  "Cancer": {
    "unicode": "♋"
  },
  "Leo": {
    "unicode": "♌"
  },
  "Virgo": {
    "unicode": "♍"
  },
  "Libra": {
    "unicode": "♎"
  },
  "Scorpio": {
    "unicode": "♏"
  },
  "Sagittarius": {
    "unicode": "♐"
  },
  "Capricorn": {
    "unicode": "♑"
  },
  "Aquarius": {
    "unicode": "♒"
  },
  "Pisces": {
    "unicode": "♓"
  },
  "Ophiuchus": {
    "unicode": "⛎"
  },
  "shuffle tracks button": {
    "unicode": "🔀"
  },
  "repeat button": {
    "unicode": "🔁"
  },
  "repeat single button": {
    "unicode": "🔂"
  },
  "play button": {
    "unicode": "▶️"
  },
  "fast-forward button": {
    "unicode": "⏩"
  },
  "next track button": {
    "unicode": "⏭️"
  },
  "play or pause button": {
    "unicode": "⏯️"
  },
  "reverse button": {
    "unicode": "◀️"
  },
  "fast reverse button": {
    "unicode": "⏪"
  },
  "last track button": {
    "unicode": "⏮️"
  },
  "upwards button": {
    "unicode": "🔼"
  },
  "fast up button": {
    "unicode": "⏫"
  },
  "downwards button": {
    "unicode": "🔽"
  },
  "fast down button": {
    "unicode": "⏬"
  },
  "pause button": {
    "unicode": "⏸️"
  },
  "stop button": {
    "unicode": "⏹️"
  },
  "record button": {
    "unicode": "⏺️"
  },
  "eject button": {
    "unicode": "⏏️"
  },
  "cinema": {
    "unicode": "🎦"
  },
  "dim button": {
    "unicode": "🔅"
  },
  "bright button": {
    "unicode": "🔆"
  },
  "antenna bars": {
    "unicode": "📶"
  },
  "vibration mode": {
    "unicode": "📳"
  },
  "mobile phone off": {
    "unicode": "📴"
  },
  "female sign": {
    "unicode": "♀️"
  },
  "male sign": {
    "unicode": "♂️"
  },
  "transgender symbol": {
    "unicode": "⚧️"
  },
  "multiply": {
    "unicode": "✖️"
  },
  "plus": {
    "unicode": "➕"
  },
  "minus": {
    "unicode": "➖"
  },
  "divide": {
    "unicode": "➗"
  },
  "infinity": {
    "unicode": "♾️"
  },
  "double exclamation mark": {
    "unicode": "‼️"
  },
  "exclamation question mark": {
    "unicode": "⁉️"
  },
  "question mark": {
    "unicode": "❓"
  },
  "white question mark": {
    "unicode": "❔"
  },
  "white exclamation mark": {
    "unicode": "❕"
  },
  "exclamation mark": {
    "unicode": "❗"
  },
  "wavy dash": {
    "unicode": "〰️"
  },
  "currency exchange": {
    "unicode": "💱"
  },
  "heavy dollar sign": {
    "unicode": "💲"
  },
  "medical symbol": {
    "unicode": "⚕️"
  },
  "recycling symbol": {
    "unicode": "♻️"
  },
  "fleur-de-lis": {
    "unicode": "⚜️"
  },
  "trident emblem": {
    "unicode": "🔱"
  },
  "name badge": {
    "unicode": "📛"
  },
  "Japanese symbol for beginner": {
    "unicode": "🔰"
  },
  "hollow red circle": {
    "unicode": "⭕"
  },
  "check mark button": {
    "unicode": "✅"
  },
  "check box with check": {
    "unicode": "☑️"
  },
  "check mark": {
    "unicode": "✔️"
  },
  "cross mark": {
    "unicode": "❌"
  },
  "cross mark button": {
    "unicode": "❎"
  },
  "curly loop": {
    "unicode": "➰"
  },
  "double curly loop": {
    "unicode": "➿"
  },
  "part alternation mark": {
    "unicode": "〽️"
  },
  "eight-spoked asterisk": {
    "unicode": "✳️"
  },
  "eight-pointed star": {
    "unicode": "✴️"
  },
  "sparkle": {
    "unicode": "❇️"
  },
  "copyright": {
    "unicode": "©️"
  },
  "registered": {
    "unicode": "®️"
  },
  "trade mark": {
    "unicode": "™️"
  },
  "keycap: #": {
    "unicode": "#️⃣"
  },
  "keycap: *": {
    "unicode": "*️⃣"
  },
  "keycap: 0": {
    "unicode": "0️⃣"
  },
  "keycap: 1": {
    "unicode": "1️⃣"
  },
  "keycap: 2": {
    "unicode": "2️⃣"
  },
  "keycap: 3": {
    "unicode": "3️⃣"
  },
  "keycap: 4": {
    "unicode": "4️⃣"
  },
  "keycap: 5": {
    "unicode": "5️⃣"
  },
  "keycap: 6": {
    "unicode": "6️⃣"
  },
  "keycap: 7": {
    "unicode": "7️⃣"
  },
  "keycap: 8": {
    "unicode": "8️⃣"
  },
  "keycap: 9": {
    "unicode": "9️⃣"
  },
  "keycap: 10": {
    "unicode": "🔟"
  },
  "input latin uppercase": {
    "unicode": "🔠"
  },
  "input latin lowercase": {
    "unicode": "🔡"
  },
  "input numbers": {
    "unicode": "🔢"
  },
  "input symbols": {
    "unicode": "🔣"
  },
  "input latin letters": {
    "unicode": "🔤"
  },
  "A button (blood type)": {
    "unicode": "🅰️"
  },
  "AB button (blood type)": {
    "unicode": "🆎"
  },
  "B button (blood type)": {
    "unicode": "🅱️"
  },
  "CL button": {
    "unicode": "🆑"
  },
  "COOL button": {
    "unicode": "🆒"
  },
  "FREE button": {
    "unicode": "🆓"
  },
  "information": {
    "unicode": "ℹ️"
  },
  "ID button": {
    "unicode": "🆔"
  },
  "circled M": {
    "unicode": "Ⓜ️"
  },
  "NEW button": {
    "unicode": "🆕"
  },
  "NG button": {
    "unicode": "🆖"
  },
  "O button (blood type)": {
    "unicode": "🅾️"
  },
  "OK button": {
    "unicode": "🆗"
  },
  "P button": {
    "unicode": "🅿️"
  },
  "SOS button": {
    "unicode": "🆘"
  },
  "UP! button": {
    "unicode": "🆙"
  },
  "VS button": {
    "unicode": "🆚"
  },
  "Japanese “here” button": {
    "unicode": "🈁"
  },
  "Japanese “service charge” button": {
    "unicode": "🈂️"
  },
  "Japanese “monthly amount” button": {
    "unicode": "🈷️"
  },
  "Japanese “not free of charge” button": {
    "unicode": "🈶"
  },
  "Japanese “reserved” button": {
    "unicode": "🈯"
  },
  "Japanese “bargain” button": {
    "unicode": "🉐"
  },
  "Japanese “discount” button": {
    "unicode": "🈹"
  },
  "Japanese “free of charge” button": {
    "unicode": "🈚"
  },
  "Japanese “prohibited” button": {
    "unicode": "🈲"
  },
  "Japanese “acceptable” button": {
    "unicode": "🉑"
  },
  "Japanese “application” button": {
    "unicode": "🈸"
  },
  "Japanese “passing grade” button": {
    "unicode": "🈴"
  },
  "Japanese “vacancy” button": {
    "unicode": "🈳"
  },
  "Japanese “congratulations” button": {
    "unicode": "㊗️"
  },
  "Japanese “secret” button": {
    "unicode": "㊙️"
  },
  "Japanese “open for business” button": {
    "unicode": "🈺"
  },
  "Japanese “no vacancy” button": {
    "unicode": "🈵"
  },
  "red circle": {
    "unicode": "🔴"
  },
  "orange circle": {
    "unicode": "🟠"
  },
  "yellow circle": {
    "unicode": "🟡"
  },
  "green circle": {
    "unicode": "🟢"
  },
  "blue circle": {
    "unicode": "🔵"
  },
  "purple circle": {
    "unicode": "🟣"
  },
  "brown circle": {
    "unicode": "🟤"
  },
  "black circle": {
    "unicode": "⚫"
  },
  "white circle": {
    "unicode": "⚪"
  },
  "red square": {
    "unicode": "🟥"
  },
  "orange square": {
    "unicode": "🟧"
  },
  "yellow square": {
    "unicode": "🟨"
  },
  "green square": {
    "unicode": "🟩"
  },
  "blue square": {
    "unicode": "🟦"
  },
  "purple square": {
    "unicode": "🟪"
  },
  "brown square": {
    "unicode": "🟫"
  },
  "black large square": {
    "unicode": "⬛"
  },
  "white large square": {
    "unicode": "⬜"
  },
  "black medium square": {
    "unicode": "◼️"
  },
  "white medium square": {
    "unicode": "◻️"
  },
  "black medium-small square": {
    "unicode": "◾"
  },
  "white medium-small square": {
    "unicode": "◽"
  },
  "black small square": {
    "unicode": "▪️"
  },
  "white small square": {
    "unicode": "▫️"
  },
  "large orange diamond": {
    "unicode": "🔶"
  },
  "large blue diamond": {
    "unicode": "🔷"
  },
  "small orange diamond": {
    "unicode": "🔸"
  },
  "small blue diamond": {
    "unicode": "🔹"
  },
  "red triangle pointed up": {
    "unicode": "🔺"
  },
  "red triangle pointed down": {
    "unicode": "🔻"
  },
  "diamond with a dot": {
    "unicode": "💠"
  },
  "radio button": {
    "unicode": "🔘"
  },
  "white square button": {
    "unicode": "🔳"
  },
  "black square button": {
    "unicode": "🔲"
  },
  "chequered flag": {
    "unicode": "🏁"
  },
  "triangular flag": {
    "unicode": "🚩"
  },
  "crossed flags": {
    "unicode": "🎌"
  },
  "black flag": {
    "unicode": "🏴"
  },
  "white flag": {
    "unicode": "🏳️"
  },
  "rainbow flag": {
    "unicode": "🏳️‍🌈"
  },
  "transgender flag": {
    "unicode": "🏳️‍⚧️"
  },
  "pirate flag": {
    "unicode": "🏴‍☠️"
  },
  "flag: Ascension Island": {
    "unicode": "🇦🇨"
  },
  "flag: Andorra": {
    "unicode": "🇦🇩"
  },
  "flag: United Arab Emirates": {
    "unicode": "🇦🇪"
  },
  "flag: Afghanistan": {
    "unicode": "🇦🇫"
  },
  "flag: Antigua & Barbuda": {
    "unicode": "🇦🇬"
  },
  "flag: Anguilla": {
    "unicode": "🇦🇮"
  },
  "flag: Albania": {
    "unicode": "🇦🇱"
  },
  "flag: Armenia": {
    "unicode": "🇦🇲"
  },
  "flag: Angola": {
    "unicode": "🇦🇴"
  },
  "flag: Antarctica": {
    "unicode": "🇦🇶"
  },
  "flag: Argentina": {
    "unicode": "🇦🇷"
  },
  "flag: American Samoa": {
    "unicode": "🇦🇸"
  },
  "flag: Austria": {
    "unicode": "🇦🇹"
  },
  "flag: Australia": {
    "unicode": "🇦🇺"
  },
  "flag: Aruba": {
    "unicode": "🇦🇼"
  },
  "flag: Åland Islands": {
    "unicode": "🇦🇽"
  },
  "flag: Azerbaijan": {
    "unicode": "🇦🇿"
  },
  "flag: Bosnia & Herzegovina": {
    "unicode": "🇧🇦"
  },
  "flag: Barbados": {
    "unicode": "🇧🇧"
  },
  "flag: Bangladesh": {
    "unicode": "🇧🇩"
  },
  "flag: Belgium": {
    "unicode": "🇧🇪"
  },
  "flag: Burkina Faso": {
    "unicode": "🇧🇫"
  },
  "flag: Bulgaria": {
    "unicode": "🇧🇬"
  },
  "flag: Bahrain": {
    "unicode": "🇧🇭"
  },
  "flag: Burundi": {
    "unicode": "🇧🇮"
  },
  "flag: Benin": {
    "unicode": "🇧🇯"
  },
  "flag: St. Barthélemy": {
    "unicode": "🇧🇱"
  },
  "flag: Bermuda": {
    "unicode": "🇧🇲"
  },
  "flag: Brunei": {
    "unicode": "🇧🇳"
  },
  "flag: Bolivia": {
    "unicode": "🇧🇴"
  },
  "flag: Caribbean Netherlands": {
    "unicode": "🇧🇶"
  },
  "flag: Brazil": {
    "unicode": "🇧🇷"
  },
  "flag: Bahamas": {
    "unicode": "🇧🇸"
  },
  "flag: Bhutan": {
    "unicode": "🇧🇹"
  },
  "flag: Bouvet Island": {
    "unicode": "🇧🇻"
  },
  "flag: Botswana": {
    "unicode": "🇧🇼"
  },
  "flag: Belarus": {
    "unicode": "🇧🇾"
  },
  "flag: Belize": {
    "unicode": "🇧🇿"
  },
  "flag: Canada": {
    "unicode": "🇨🇦"
  },
  "flag: Cocos (Keeling) Islands": {
    "unicode": "🇨🇨"
  },
  "flag: Congo - Kinshasa": {
    "unicode": "🇨🇩"
  },
  "flag: Central African Republic": {
    "unicode": "🇨🇫"
  },
  "flag: Congo - Brazzaville": {
    "unicode": "🇨🇬"
  },
  "flag: Switzerland": {
    "unicode": "🇨🇭"
  },
  "flag: Côte d’Ivoire": {
    "unicode": "🇨🇮"
  },
  "flag: Cook Islands": {
    "unicode": "🇨🇰"
  },
  "flag: Chile": {
    "unicode": "🇨🇱"
  },
  "flag: Cameroon": {
    "unicode": "🇨🇲"
  },
  "flag: China": {
    "unicode": "🇨🇳"
  },
  "flag: Colombia": {
    "unicode": "🇨🇴"
  },
  "flag: Clipperton Island": {
    "unicode": "🇨🇵"
  },
  "flag: Costa Rica": {
    "unicode": "🇨🇷"
  },
  "flag: Cuba": {
    "unicode": "🇨🇺"
  },
  "flag: Cape Verde": {
    "unicode": "🇨🇻"
  },
  "flag: Curaçao": {
    "unicode": "🇨🇼"
  },
  "flag: Christmas Island": {
    "unicode": "🇨🇽"
  },
  "flag: Cyprus": {
    "unicode": "🇨🇾"
  },
  "flag: Czechia": {
    "unicode": "🇨🇿"
  },
  "flag: Germany": {
    "unicode": "🇩🇪"
  },
  "flag: Diego Garcia": {
    "unicode": "🇩🇬"
  },
  "flag: Djibouti": {
    "unicode": "🇩🇯"
  },
  "flag: Denmark": {
    "unicode": "🇩🇰"
  },
  "flag: Dominica": {
    "unicode": "🇩🇲"
  },
  "flag: Dominican Republic": {
    "unicode": "🇩🇴"
  },
  "flag: Algeria": {
    "unicode": "🇩🇿"
  },
  "flag: Ceuta & Melilla": {
    "unicode": "🇪🇦"
  },
  "flag: Ecuador": {
    "unicode": "🇪🇨"
  },
  "flag: Estonia": {
    "unicode": "🇪🇪"
  },
  "flag: Egypt": {
    "unicode": "🇪🇬"
  },
  "flag: Western Sahara": {
    "unicode": "🇪🇭"
  },
  "flag: Eritrea": {
    "unicode": "🇪🇷"
  },
  "flag: Spain": {
    "unicode": "🇪🇸"
  },
  "flag: Ethiopia": {
    "unicode": "🇪🇹"
  },
  "flag: European Union": {
    "unicode": "🇪🇺"
  },
  "flag: Finland": {
    "unicode": "🇫🇮"
  },
  "flag: Fiji": {
    "unicode": "🇫🇯"
  },
  "flag: Falkland Islands": {
    "unicode": "🇫🇰"
  },
  "flag: Micronesia": {
    "unicode": "🇫🇲"
  },
  "flag: Faroe Islands": {
    "unicode": "🇫🇴"
  },
  "flag: France": {
    "unicode": "🇫🇷"
  },
  "flag: Gabon": {
    "unicode": "🇬🇦"
  },
  "flag: United Kingdom": {
    "unicode": "🇬🇧"
  },
  "flag: Grenada": {
    "unicode": "🇬🇩"
  },
  "flag: Georgia": {
    "unicode": "🇬🇪"
  },
  "flag: French Guiana": {
    "unicode": "🇬🇫"
  },
  "flag: Guernsey": {
    "unicode": "🇬🇬"
  },
  "flag: Ghana": {
    "unicode": "🇬🇭"
  },
  "flag: Gibraltar": {
    "unicode": "🇬🇮"
  },
  "flag: Greenland": {
    "unicode": "🇬🇱"
  },
  "flag: Gambia": {
    "unicode": "🇬🇲"
  },
  "flag: Guinea": {
    "unicode": "🇬🇳"
  },
  "flag: Guadeloupe": {
    "unicode": "🇬🇵"
  },
  "flag: Equatorial Guinea": {
    "unicode": "🇬🇶"
  },
  "flag: Greece": {
    "unicode": "🇬🇷"
  },
  "flag: South Georgia & South Sandwich Islands": {
    "unicode": "🇬🇸"
  },
  "flag: Guatemala": {
    "unicode": "🇬🇹"
  },
  "flag: Guam": {
    "unicode": "🇬🇺"
  },
  "flag: Guinea-Bissau": {
    "unicode": "🇬🇼"
  },
  "flag: Guyana": {
    "unicode": "🇬🇾"
  },
  "flag: Hong Kong SAR China": {
    "unicode": "🇭🇰"
  },
  "flag: Heard & McDonald Islands": {
    "unicode": "🇭🇲"
  },
  "flag: Honduras": {
    "unicode": "🇭🇳"
  },
  "flag: Croatia": {
    "unicode": "🇭🇷"
  },
  "flag: Haiti": {
    "unicode": "🇭🇹"
  },
  "flag: Hungary": {
    "unicode": "🇭🇺"
  },
  "flag: Canary Islands": {
    "unicode": "🇮🇨"
  },
  "flag: Indonesia": {
    "unicode": "🇮🇩"
  },
  "flag: Ireland": {
    "unicode": "🇮🇪"
  },
  "flag: Israel": {
    "unicode": "🇮🇱"
  },
  "flag: Isle of Man": {
    "unicode": "🇮🇲"
  },
  "flag: India": {
    "unicode": "🇮🇳"
  },
  "flag: British Indian Ocean Territory": {
    "unicode": "🇮🇴"
  },
  "flag: Iraq": {
    "unicode": "🇮🇶"
  },
  "flag: Iran": {
    "unicode": "🇮🇷"
  },
  "flag: Iceland": {
    "unicode": "🇮🇸"
  },
  "flag: Italy": {
    "unicode": "🇮🇹"
  },
  "flag: Jersey": {
    "unicode": "🇯🇪"
  },
  "flag: Jamaica": {
    "unicode": "🇯🇲"
  },
  "flag: Jordan": {
    "unicode": "🇯🇴"
  },
  "flag: Japan": {
    "unicode": "🇯🇵"
  },
  "flag: Kenya": {
    "unicode": "🇰🇪"
  },
  "flag: Kyrgyzstan": {
    "unicode": "🇰🇬"
  },
  "flag: Cambodia": {
    "unicode": "🇰🇭"
  },
  "flag: Kiribati": {
    "unicode": "🇰🇮"
  },
  "flag: Comoros": {
    "unicode": "🇰🇲"
  },
  "flag: St. Kitts & Nevis": {
    "unicode": "🇰🇳"
  },
  "flag: North Korea": {
    "unicode": "🇰🇵"
  },
  "flag: South Korea": {
    "unicode": "🇰🇷"
  },
  "flag: Kuwait": {
    "unicode": "🇰🇼"
  },
  "flag: Cayman Islands": {
    "unicode": "🇰🇾"
  },
  "flag: Kazakhstan": {
    "unicode": "🇰🇿"
  },
  "flag: Laos": {
    "unicode": "🇱🇦"
  },
  "flag: Lebanon": {
    "unicode": "🇱🇧"
  },
  "flag: St. Lucia": {
    "unicode": "🇱🇨"
  },
  "flag: Liechtenstein": {
    "unicode": "🇱🇮"
  },
  "flag: Sri Lanka": {
    "unicode": "🇱🇰"
  },
  "flag: Liberia": {
    "unicode": "🇱🇷"
  },
  "flag: Lesotho": {
    "unicode": "🇱🇸"
  },
  "flag: Lithuania": {
    "unicode": "🇱🇹"
  },
  "flag: Luxembourg": {
    "unicode": "🇱🇺"
  },
  "flag: Latvia": {
    "unicode": "🇱🇻"
  },
  "flag: Libya": {
    "unicode": "🇱🇾"
  },
  "flag: Morocco": {
    "unicode": "🇲🇦"
  },
  "flag: Monaco": {
    "unicode": "🇲🇨"
  },
  "flag: Moldova": {
    "unicode": "🇲🇩"
  },
  "flag: Montenegro": {
    "unicode": "🇲🇪"
  },
  "flag: St. Martin": {
    "unicode": "🇲🇫"
  },
  "flag: Madagascar": {
    "unicode": "🇲🇬"
  },
  "flag: Marshall Islands": {
    "unicode": "🇲🇭"
  },
  "flag: North Macedonia": {
    "unicode": "🇲🇰"
  },
  "flag: Mali": {
    "unicode": "🇲🇱"
  },
  "flag: Myanmar (Burma)": {
    "unicode": "🇲🇲"
  },
  "flag: Mongolia": {
    "unicode": "🇲🇳"
  },
  "flag: Macao SAR China": {
    "unicode": "🇲🇴"
  },
  "flag: Northern Mariana Islands": {
    "unicode": "🇲🇵"
  },
  "flag: Martinique": {
    "unicode": "🇲🇶"
  },
  "flag: Mauritania": {
    "unicode": "🇲🇷"
  },
  "flag: Montserrat": {
    "unicode": "🇲🇸"
  },
  "flag: Malta": {
    "unicode": "🇲🇹"
  },
  "flag: Mauritius": {
    "unicode": "🇲🇺"
  },
  "flag: Maldives": {
    "unicode": "🇲🇻"
  },
  "flag: Malawi": {
    "unicode": "🇲🇼"
  },
  "flag: Mexico": {
    "unicode": "🇲🇽"
  },
  "flag: Malaysia": {
    "unicode": "🇲🇾"
  },
  "flag: Mozambique": {
    "unicode": "🇲🇿"
  },
  "flag: Namibia": {
    "unicode": "🇳🇦"
  },
  "flag: New Caledonia": {
    "unicode": "🇳🇨"
  },
  "flag: Niger": {
    "unicode": "🇳🇪"
  },
  "flag: Norfolk Island": {
    "unicode": "🇳🇫"
  },
  "flag: Nigeria": {
    "unicode": "🇳🇬"
  },
  "flag: Nicaragua": {
    "unicode": "🇳🇮"
  },
  "flag: Netherlands": {
    "unicode": "🇳🇱"
  },
  "flag: Norway": {
    "unicode": "🇳🇴"
  },
  "flag: Nepal": {
    "unicode": "🇳🇵"
  },
  "flag: Nauru": {
    "unicode": "🇳🇷"
  },
  "flag: Niue": {
    "unicode": "🇳🇺"
  },
  "flag: New Zealand": {
    "unicode": "🇳🇿"
  },
  "flag: Oman": {
    "unicode": "🇴🇲"
  },
  "flag: Panama": {
    "unicode": "🇵🇦"
  },
  "flag: Peru": {
    "unicode": "🇵🇪"
  },
  "flag: French Polynesia": {
    "unicode": "🇵🇫"
  },
  "flag: Papua New Guinea": {
    "unicode": "🇵🇬"
  },
  "flag: Philippines": {
    "unicode": "🇵🇭"
  },
  "flag: Pakistan": {
    "unicode": "🇵🇰"
  },
  "flag: Poland": {
    "unicode": "🇵🇱"
  },
  "flag: St. Pierre & Miquelon": {
    "unicode": "🇵🇲"
  },
  "flag: Pitcairn Islands": {
    "unicode": "🇵🇳"
  },
  "flag: Puerto Rico": {
    "unicode": "🇵🇷"
  },
  "flag: Palestinian Territories": {
    "unicode": "🇵🇸"
  },
  "flag: Portugal": {
    "unicode": "🇵🇹"
  },
  "flag: Palau": {
    "unicode": "🇵🇼"
  },
  "flag: Paraguay": {
    "unicode": "🇵🇾"
  },
  "flag: Qatar": {
    "unicode": "🇶🇦"
  },
  "flag: Réunion": {
    "unicode": "🇷🇪"
  },
  "flag: Romania": {
    "unicode": "🇷🇴"
  },
  "flag: Serbia": {
    "unicode": "🇷🇸"
  },
  "flag: Russia": {
    "unicode": "🇷🇺"
  },
  "flag: Rwanda": {
    "unicode": "🇷🇼"
  },
  "flag: Saudi Arabia": {
    "unicode": "🇸🇦"
  },
  "flag: Solomon Islands": {
    "unicode": "🇸🇧"
  },
  "flag: Seychelles": {
    "unicode": "🇸🇨"
  },
  "flag: Sudan": {
    "unicode": "🇸🇩"
  },
  "flag: Sweden": {
    "unicode": "🇸🇪"
  },
  "flag: Singapore": {
    "unicode": "🇸🇬"
  },
  "flag: St. Helena": {
    "unicode": "🇸🇭"
  },
  "flag: Slovenia": {
    "unicode": "🇸🇮"
  },
  "flag: Svalbard & Jan Mayen": {
    "unicode": "🇸🇯"
  },
  "flag: Slovakia": {
    "unicode": "🇸🇰"
  },
  "flag: Sierra Leone": {
    "unicode": "🇸🇱"
  },
  "flag: San Marino": {
    "unicode": "🇸🇲"
  },
  "flag: Senegal": {
    "unicode": "🇸🇳"
  },
  "flag: Somalia": {
    "unicode": "🇸🇴"
  },
  "flag: Suriname": {
    "unicode": "🇸🇷"
  },
  "flag: South Sudan": {
    "unicode": "🇸🇸"
  },
  "flag: São Tomé & Príncipe": {
    "unicode": "🇸🇹"
  },
  "flag: El Salvador": {
    "unicode": "🇸🇻"
  },
  "flag: Sint Maarten": {
    "unicode": "🇸🇽"
  },
  "flag: Syria": {
    "unicode": "🇸🇾"
  },
  "flag: Eswatini": {
    "unicode": "🇸🇿"
  },
  "flag: Tristan da Cunha": {
    "unicode": "🇹🇦"
  },
  "flag: Turks & Caicos Islands": {
    "unicode": "🇹🇨"
  },
  "flag: Chad": {
    "unicode": "🇹🇩"
  },
  "flag: French Southern Territories": {
    "unicode": "🇹🇫"
  },
  "flag: Togo": {
    "unicode": "🇹🇬"
  },
  "flag: Thailand": {
    "unicode": "🇹🇭"
  },
  "flag: Tajikistan": {
    "unicode": "🇹🇯"
  },
  "flag: Tokelau": {
    "unicode": "🇹🇰"
  },
  "flag: Timor-Leste": {
    "unicode": "🇹🇱"
  },
  "flag: Turkmenistan": {
    "unicode": "🇹🇲"
  },
  "flag: Tunisia": {
    "unicode": "🇹🇳"
  },
  "flag: Tonga": {
    "unicode": "🇹🇴"
  },
  "flag: Turkey": {
    "unicode": "🇹🇷"
  },
  "flag: Trinidad & Tobago": {
    "unicode": "🇹🇹"
  },
  "flag: Tuvalu": {
    "unicode": "🇹🇻"
  },
  "flag: Taiwan": {
    "unicode": "🇹🇼"
  },
  "flag: Tanzania": {
    "unicode": "🇹🇿"
  },
  "flag: Ukraine": {
    "unicode": "🇺🇦"
  },
  "flag: Uganda": {
    "unicode": "🇺🇬"
  },
  "flag: U.S. Outlying Islands": {
    "unicode": "🇺🇲"
  },
  "flag: United Nations": {
    "unicode": "🇺🇳"
  },
  "flag: United States": {
    "unicode": "🇺🇸"
  },
  "flag: Uruguay": {
    "unicode": "🇺🇾"
  },
  "flag: Uzbekistan": {
    "unicode": "🇺🇿"
  },
  "flag: Vatican City": {
    "unicode": "🇻🇦"
  },
  "flag: St. Vincent & Grenadines": {
    "unicode": "🇻🇨"
  },
  "flag: Venezuela": {
    "unicode": "🇻🇪"
  },
  "flag: British Virgin Islands": {
    "unicode": "🇻🇬"
  },
  "flag: U.S. Virgin Islands": {
    "unicode": "🇻🇮"
  },
  "flag: Vietnam": {
    "unicode": "🇻🇳"
  },
  "flag: Vanuatu": {
    "unicode": "🇻🇺"
  },
  "flag: Wallis & Futuna": {
    "unicode": "🇼🇫"
  },
  "flag: Samoa": {
    "unicode": "🇼🇸"
  },
  "flag: Kosovo": {
    "unicode": "🇽🇰"
  },
  "flag: Yemen": {
    "unicode": "🇾🇪"
  },
  "flag: Mayotte": {
    "unicode": "🇾🇹"
  },
  "flag: South Africa": {
    "unicode": "🇿🇦"
  },
  "flag: Zambia": {
    "unicode": "🇿🇲"
  },
  "flag: Zimbabwe": {
    "unicode": "🇿🇼"
  },
  "flag: England": {
    "unicode": "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
  },
  "flag: Scotland": {
    "unicode": "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
  },
  "flag: Wales": {
    "unicode": "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
  }
}